
function Victim(){}
(function(mData,mControls){
    //Variables
    //mEnrolleesControls.CardViewVictimFilter    
    function CardViewVictimFilter_Init(){
        var lUserPreferences = getUserPreferences(2);
        var cardViewParams = {
            'Title': localizeWrapper('cEnrolleeFindVictims'),
            'Content': '',
            'CssClass': 'DefaultFilter',
            'HideOnFilter': true,
            'OnFilter': CardViewFilter_OnFilter,
            'Columns': [
                { 'Id': 'FullName', 'Title': localizeWrapper('cEnrolleeName'), 'Type': 'Text', 'DataField': 'FullName' },
                { 'Id': 'PrimaryID', 'Title': localizeWrapper('cEnrolleePrimaryId'), 'Type': 'Text', 'DataField': 'PrimaryId' },
                { 'Id': 'AgentName', 'Title': localizeWrapper('cAgent'), 'Type': 'Text', 'DataField': 'AgentName' },
                { 'Id': 'IsAssigned', 'Title': localizeWrapper('cEnrolleeIsAssigned'), 'Type': 'Dropdown', 'DataField': 'IsAssigned', 'DataSource': [{ 'Value': true, 'Text': localizeText('cYes') }, { 'Value': false, 'Text': localizeText('cNo') }], 'DataValueField': 'Value', 'DataTextField': 'Text', 'DefaultValue': false, 'ComparisonType': 'Boolean', 'InsertBlank': true, 'BlankText': localizeText('cBoth') }
            ],
            'Settings': null,
            'UserPreferences': lUserPreferences,
            'UserId': gUserDetails.UserId,
            'UserPreferenceType': 2
        };
        mData.TargetId = -1;
        if (isNullOrUndefined(mControls.CardViewVictimFilter)) {
            mControls.CardViewVictimFilter = gFilterFactory.createControl('uVictimsCardViewFilter', 'uEnrolleesListFilterHolder', cardViewParams);
        } else {
            mControls.CardViewVictimFilter.render();
        }
    }
    //CardViewVictimFilter Events
    var CardViewFilter_OnFilter = function (aSender, aExpression, aData){
        console.log('CardViewFilter_OnFilter',aExpression);
        mData.VictimDirty = getVictimDirty(aExpression);
        mData.VictimPaginated = mControls.CardViewVictimPaginator.paginate(mData.VictimDirty);
        if (!isNullOrUndefined(mControls.CardView)) {
            mControls.CardView.setDataSource(mEnrolleesData.VictimPaginated);
        }
    };
    //mEnrolleesControls.CardViewVictimPaginator
    function CardViewVictimPaginator_Init(){
        if (isNullOrUndefined(mControls.CardViewVictimPaginator)) {
            mControls.CardViewVictimPaginator = new sumo.controls.Paginator('uVictimsCardViewPaginator', 'uEnrolleesPagerHolder', {
                'ItemCount': count(mData.VictimDirty),
                'ItemsPerPage': gPaginationSettings.EnrolleesVictimsItems
            });
            mControls.CardViewVictimPaginator.bind('pagechanged', Paginator_OnPageChanged);
            //Victim.uVictimsPaginator_OnPageChanged
        } else {
            mControls.CardViewVictimPaginator.render();
        }
    }
    //CardViewVictimPaginator Events
    var Paginator_OnPageChanged = function(aSender, aNewPage, aData) {
        if (!isNullOrUndefined(mData.VictimDirty)) {
            var lData = aSender.paginate(mData.VictimDirty);
            for (var lKeyA in lData) {
                if (lData.hasOwnProperty(lKeyA)) {
                    lData[lKeyA].EventIconDisplay = 'none';
                }
            }
            mControls.CardView.setDataSource(lData);
        }
        setViewState('EnrolleesSelectedPage', aNewPage);
    };

    
    //GLOBALS
    window.mStateManagerEnrolleesVictimsLayout_Init = function (aPrevHash,aNewHash){
        // Victim.uVictimsCardViewFilter_Init();
        // Victim.uVictimsCardViewPaginator_Init();
        mStateManager.ChangeSettings(2,'Events');
        $('#uEnrolleesMobileApp').hide();
        CardViewVictimFilter_Init();
        CardViewVictimPaginator_Init();
        mControls.CardViewVictimFilter.filter();
    };

    //EnrolleeCardView Dirty;
    function getVictimDirty(aExpression){
        var aVictimDirty=null;
        if (mData.TargetId === -1) {
            aVictimDirty = query(mData.VictimClean, aExpression);
            deleteViewState('SpatialMatchesEnrollee');
        } else {
            lBuilder = new SumoPredicateBuilder();
            lBuilder.AddNewExpressionConditional('Id', mData.TargetId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
            aVictimDirty = query(mData.VictimClean, lBuilder.RootExpression);
            mData.TargetId = -1;
        }
        return aVictimDirty;
    }
})(mEnrolleesData,mEnrolleesControls);

Victim.uVictimsCardViewFilter_OnFilter = function (aSender, aExpression, aData) {
    "use strict";
    var lData,
        lBuilder,
        lCardView;
    if (mEnrolleesData.TargetId === -1) {
        mEnrolleesData.VictimDirty = query(mEnrolleesData.VictimClean, aExpression);
        deleteViewState('SpatialMatchesEnrollee');
    } else {
        lBuilder = new SumoPredicateBuilder();
        lBuilder.AddNewExpressionConditional('Id', mEnrolleesData.TargetId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        mEnrolleesData.VictimDirty = query(mEnrolleesData.VictimClean, lBuilder.RootExpression);
        mEnrolleesData.TargetId = -1;
    }
    mEnrolleesData.VictimPaginated = mEnrolleesControls.CardViewVictimPaginator.paginate(mEnrolleesData.VictimDirty);
    lCardView = mEnrolleesControls.CardView;
    if (!isNullOrUndefined(lCardView)) {
        lCardView.setDataSource(mEnrolleesData.VictimPaginated);
    }
};

Victim.VictimPage_uRefreshButton_OnClick = function() {
    "use strict";
    mEnrolleesData.MapEndDate = new Date();
    mEnrolleesData.MapPageMultiplier = 0;

    uEnrolleesCardView_OnUpdate();
    Victim.victimMapPopulate();
    if (!isNullOrUndefined(mEnrolleesData.VictimSecondaryCurrentId)) {
        offenderSecondaryVictimMapPopulate();
    }
}

Victim.uVictimsPaginator_OnPageChanged = function (aSender, aNewPage, aData) {
    if (!isNullOrUndefined(mEnrolleesData.VictimDirty)) {
        var lData = aSender.paginate(mEnrolleesData.VictimDirty);
        for (var lKeyA in lData) {
            if (lData.hasOwnProperty(lKeyA)) {
                lData[lKeyA].EventIconDisplay = 'none';
            }
        }
        mEnrolleesControls.CardView.setDataSource(lData);
    }
    setViewState('EnrolleesSelectedPage', aNewPage);
};

Victim.gCardViewFactory_OnVictimInit = function (aSender, aEvent, aData) {
    var lParams = {
        'Title': '',
        'DataSource': null,
        'CardTemplate': 'Interface/Enrollees.Card.Template.htm',
        'TemplateType': 'uri',
        'OnSelectedChanged': Victim.uVictimsList_OnSelectChange,
        'OnRender': gCardViewFactory_OnRender,
        'DataConverter': null
    };
    gCardViewFactory.createControl(
        'uVictimsCardView',
        'uEnrolleesListHolder',
        lParams);
};

Victim.gFilterFactory_OnVictimsInit = function (aSender, aEvent, aData) {
    var lParams = {
        'Title': 'Find Victims',
        'Content': '',
        'HideOnFilter': true,
        'OnFilter': Victim.uVictimsCardViewFilter_OnFilter,
        'Columns': [
        ],
        'Settings': null
    };

    aSender.createControl(
        'uVictimsCardViewFilter',
        'uEnrolleesListFilterHolder',
        lParams);
};

Victim.gPaginatorFactory_OnVictimsInit = function (aSender, aEvent, aData) {
    var lPaginator = aSender.createControl('uVictimsPaginator', 'uEnrolleesPagerHolder', {
        'ItemCount': count(mEnrolleesData.VictimDirty),
        'ItemsPerPage': 50
    });

    lPaginator.bind('pagechanged', Victim.uVictimsPaginator_OnPageChanged);
    lPaginator.trigger('pagechanged');
};

Victim.uVictimsList_Init = function () {
    if (isNullOrUndefined(mEnrolleesData.VictimDirty)) {
        mEnrolleesData.VictimDirty = mEnrolleesData.VictimClean;
    }

    if (isNullOrUndefined(gFilterFactory.Controls['uVictimsCardViewFilter'])) {
        gFilterFactory_OnVictimsInit(gFilterFactory, null, null);
    } else {
        gFilterFactory.Controls['uVictimsCardViewFilter'].render();
    }
    if (isNullOrUndefined(gPaginatorFactory.Controls['uVictimsPaginator'])) {
        gPaginatorFactory_OnVictimsInit(gPaginatorFactory, null, null);
    } else {
        gPaginatorFactory.Controls['uVictimsPaginator'].render();
        gPaginatorFactory.Controls['uVictimsPaginator'].trigger('pagechanged');
    }
};

Victim.mapping_filter = function (aSender, aExpression, aParams) {
    "use strict";
    var lCardList = [],
        lCardList2 = [],
        lCardDisplay = [],
        lSort = new SortExpression(),
        lLabelList = [],
        lTagList = [],
        lMarkerList = [],
        lTagLabelList = [],
        lAddressList = [],
        lZoneList = [],
        lPrimaryTrackpointList = [],
        lSecondaryTrackpointList = [],
        lDisplayConnectedTracks = true,
        lDisplayLabel = true,
        lTrackPointCount = 0,
        lExpandedTrackPointCount = 0,
        lVisitCount = 0,
        lCardCount = 0,
        lEnrollee = getDataItem(mEnrolleesData.VictimCurrentId, 'Enrollees'),
        lSecondaryEnrollee,
        lMapBounds,
        lTrackItem,
        lPreferences = getUserPreferences(4),
        lPreference,
        lTrackTypeValue,
        lTrackpointCountDetail,
        lItem,
        lFixedMarkerElement,
        lValue = mEnrolleesControls.VictimTrackpointDetailCardViewFilter.columnValue('TypeVictim'),
        lKey,
        lIsInformatics = false,
        lTrackpointEventsFilter = true;

    //Used to possibly map the victim if the victim is assigned to the victim
    if (!isNullOrUndefined(lEnrollee)) {
        lIsInformatics = getInformaticsEnabled(lEnrollee.OrganizationId);
    }
    if (!isNullOrUndefined(mEnrolleesData.VictimSecondaryCurrentId)) {
        lSecondaryEnrollee = getDataItem(mEnrolleesData.VictimSecondaryCurrentId, 'Enrollees');

        if (isNullOrUndefined(lSecondaryEnrollee)) {
            lSecondaryEnrollee = getDataItem(mEnrolleesData.VictimSecondaryCurrentId, 'EnrolleesUniversal');
        }
    }
    if (!isNullOrUndefined(aExpression)) {
        if (aExpression.__type === 'ExpressionConditional:www.sumosoftware.com/Expressions') {
            lDisplayLabel = (aExpression.Name === 'Type' && aExpression.Value.indexOf('10') !== -1);
            lDisplayConnectedTracks = (aExpression.Name === 'Type' && aExpression.Value.indexOf('7') !== -1);
            lTrackpointEventsFilter = (aExpression.Name === 'Type' && aExpression.Value.indexOf('20') !== -1);
        } else if (aExpression.__type === 'ExpressionBinary:www.sumosoftware.com/Expressions') {
            lDisplayLabel = (aExpression.LeftOperand.Name === 'Type' && aExpression.LeftOperand.Value.indexOf('10') !== -1) || (aExpression.RightOperand.Name === 'Type' && aExpression.RightOperand.Value.indexOf('10') !== -1);
            lDisplayConnectedTracks = (aExpression.LeftOperand.Name === 'Type' && aExpression.LeftOperand.Value.indexOf('7') !== -1) || (aExpression.RightOperand.Name === 'Type' && aExpression.RightOperand.Value.indexOf('7') !== -1);
            lTrackpointEventsFilter = (aExpression.LeftOperand.Name === 'Type' && aExpression.LeftOperand.Value.indexOf('20') !== -1) || (aExpression.RightOperand.Name === 'Type' && aExpression.RightOperand.Value.indexOf('20') !== -1);
        }

    }
    else if (!$('#uShowTrackPointEventsButton').hasClass('Selected')) {
        lTrackpointEventsFilter = false;
    }
    lCardList = veritracks.enrollees.mapping.data.PrimaryCardList;
    if (mEnrolleesData.VictimCurrentId !== mEnrolleesData.VictimSecondaryCurrentId && !isNullOrUndefined(mEnrolleesData.VictimSecondaryCurrentId)) {
        lCardList = lCardList.concat(veritracks.enrollees.mapping.data.SecondaryCardList);
    }
    else {
        veritracks.enrollees.mapping.data.SecondaryCardList = [];
    }
    //lCardList = lCardList.concat(veritracks.enrollees.mapping.data.TagCardList);

    lCardList = query(lCardList, aExpression);
    lSort.addAscendingColumn('SortOrder');
    lSort.addDescendingColumn('SortDate');
    lSort.addAscendingColumn('Type');
    lCardList = lSort.sort(lCardList);

    // place Addresses and zones at the bottom
    lCardList = veritracks.enrollees.mapping.FixCardSortOrder(lCardList);
    lTrackpointEventsFilter = lIsInformatics == true ? !lTrackpointEventsFilter : lTrackpointEventsFilter;
    if (!lTrackpointEventsFilter || !lEnrollee.InMyOrganization) {
        lCardList = veritracks.enrollees.mapping.TrackpointEventsFilter(lCardList);
    }
    lCardCount = veritracks.enrollees.mapping.TrackPointDetailCardViewCounter(lCardList);

    for (lKey in lCardList) {
        if (lCardList.hasOwnProperty(lKey)) {
            lItem = $.extend({}, lCardList[lKey]);
            lItem.DisplayName = lItem.Name + ' (' + veritracks.enrollees.mapping.CardParsedName(lItem) + veritracks.enrollees.mapping.CountFixer(lCardCount,lItem).toString() + ')';
            lCardDisplay.push(lItem);
            lTrackItem = lItem.TrackItem;
            switch (lItem.SortOrder) {
                case 0:
                    lTagList.push(lTrackItem);
                    lTagLabelList.push(lTrackItem.data);
                    break;
                case 1:
                    lAddressList.push(lTrackItem);
                    if (lDisplayLabel) {
                        lLabelList.push(lItem);
                    }
                    break;
                case 2:
                    lZoneList.push(lTrackItem);
                    break;
                case 3:
                    switch (lItem.Type) {
                        case 4:
                            if (lItem.TrackItem.data.TrackTypeId == 1) {
                                ++lExpandedTrackPointCount;
                            }
                            break;
                        case 5:
                            if (lItem.TrackItem.data.TrackTypeId == 1) {
                                ++lTrackPointCount;
                            }
                            break;
                    }
                    if (lItem.EnrolleeId === mEnrolleesData.VictimCurrentId) {
                        lTrackItem.data.TimeZoneId = lEnrollee.TimeZoneId;
                        lTrackItem.data.Count = veritracks.enrollees.mapping.CountFixer(lCardCount, lItem);
                        if (lIsInformatics) {
                            lTrackItem.TrackItem = { 'index': lTrackItem.index, 'SVGMarker': lTrackItem.SVGMarker, 'degreeRotation': lTrackItem.degreeRotation, 'centerX': lTrackItem.centerX, 'centerY': lTrackItem.centerY };
                        }
                        lPrimaryTrackpointList.push(lTrackItem);
                    } else {
                        if (lSecondaryEnrollee) {
                            lTrackItem.data.TimeZoneId = lSecondaryEnrollee.TimeZoneId;
                            lTrackItem.data.Count = veritracks.enrollees.mapping.CountFixer(lCardCount, lItem);
                            lSecondaryTrackpointList.push(lTrackItem);
                        }
                        
                    }
                    if (lDisplayLabel) {
                        lLabelList.push(lItem);
                    }
                    break;
                case 4:
                    lAlcoholList.push(lTrackItem);
                    break;
            }
            lCardCount = veritracks.enrollees.mapping.CountKeeper(lItem, lCardCount);
        }
    }
    if (lIsInformatics) {
        for (lKey in veritracks.mapping.data.EnumeratedIcons) {
            if (veritracks.mapping.data.EnumeratedIcons.hasOwnProperty(lKey)) {
                lFixedMarkerElement = $.extend({}, mEnrolleesIcon.icons[0]);
                if (isNullOrUndefined(veritracks.mapping.data.EnumeratedIcons[lKey].FileMarker) || veritracks.mapping.data.EnumeratedIcons[lKey].FileMarker) {
                    lFixedMarkerElement.IconName = lKey;
                    lFixedMarkerElement.IconValue = veritracks.mapping.iconGenerator.cleanSVGTag(veritracks.mapping.data.EnumeratedIcons[lKey].SVGMarker, true);
                    lFixedMarkerElement.Id = -1;
                    lFixedMarkerElement.DegreeRotation = veritracks.mapping.data.EnumeratedIcons[lKey].BearingDegree
                    lFixedMarkerElement.CenterX = veritracks.mapping.data.EnumeratedIcons[lKey].CenterX;
                    lFixedMarkerElement.CenterY = veritracks.mapping.data.EnumeratedIcons[lKey].CenterY;
                    lMarkerList.push(lFixedMarkerElement);
                }                   
            }
        }
    }
    GenerateIconsPng(lMarkerList, function AfterGeneratingIcons(){
        lPrimaryTrackpointList.reverse();
        lTagLabelList = veritracks.mapping.prepareSuggestionLabelOverlayData(lTagLabelList);
        
        mEnrolleesControls.VictimTrackpointDetailCardView.setDataSource(lCardDisplay);

        lMapBounds = mEnrolleesControls.EnrolleesMap.getBoundsFromArray(lPrimaryTrackpointList);

        mEnrolleesControls.EnrolleesMap.layerSetDataSource('Tags', lTagList);
        mEnrolleesControls.EnrolleesMap.layerSetDataSource('TagLabels', lTagLabelList);
        mEnrolleesControls.EnrolleesMap.layerSetDataSource('Addresses', lAddressList);
        mEnrolleesControls.EnrolleesMap.layerSetDataSource('Zones', lZoneList);
        mEnrolleesControls.EnrolleesMap.layerSetDataSource('ZonesNames', veritracks.mapping.prepareEnrolleesZoneLabelOverlayData(lZoneList));

        mEnrolleesControls.EnrolleesMap.layerSetDataSource('Visits', lPrimaryTrackpointList);
        mEnrolleesControls.EnrolleesMap.layerSetDataSource('SecondaryVisits', lSecondaryTrackpointList);
        if (lDisplayConnectedTracks) {
            mEnrolleesControls.EnrolleesMap.layerSetDataSource('ConnectedTracks', veritracks.mapping.prepareTripPointLineSegmentData(lPrimaryTrackpointList));
            mEnrolleesControls.EnrolleesMap.layerSetDataSource('SecondaryConnectedTracks', veritracks.mapping.prepareTripPointLineSegmentData(lSecondaryTrackpointList));
        } else {
            mEnrolleesControls.EnrolleesMap.layerSetDataSource('ConnectedTracks', []);
            mEnrolleesControls.EnrolleesMap.layerSetDataSource('SecondaryConnectedTracks', []);
        }
        mEnrolleesControls.EnrolleesMap.layerSetDataSource('Labels', veritracks.mapping.prepareTrackpointDetailCardLabelOverlayData(lLabelList, lValue));

        if (lCardDisplay.length > 0) {
            if (veritracks.enrollees.mapping.data.DoFitBounds) {
                if (!lMapBounds.isEmpty()) {
                    mEnrolleesControls.EnrolleesMap.fitBounds(lMapBounds);
                } else {
                    mEnrolleesControls.EnrolleesMap.fitBounds();
                }
            }
        
            //mEnrolleesControls.EnrolleesMap.zoom(
            $('#uEnrolleesNoData').hide();
            $('#uEnrolleesNoDataText').empty();
        } else {
            if (veritracks.enrollees.mapping.data.PrimaryCardList.length > 0 || veritracks.enrollees.mapping.data.SecondaryCardList.length > 0) {
                $('#uEnrolleesNoDataText').text('No track data available for current filter.');
            } else {
                $('#uEnrolleesNoDataText').text('No track data available.');
            }
            $('#uEnrolleesNoData').show();
            uTrackpointDetailCardView_OnSelectChange(mEnrolleesControls.VictimTrackpointDetailCardView, null, null);
            //mEnrolleesControls.victimTrackpointDetailCardView.selected(-1);
        }
        veritracks.enrollees.mapping.data.DoFitBounds = true;

        lPreference = lPreferences['TrackType'];

        if (!isNullOrUndefined(lPreference)) {
            lTrackTypeValue = parseInt(lPreference.Value, 10);
        }
        var lCount = 0;
        // if (lVisitCount > 0) {
        lVisitCount = CalculateVisitCount();
        lCount = CalculateVisitTrackPointCount(false)
        //  }
        var lTrackPointCount = CalculateTrackpointCount();
        lCount += lTrackPointCount;
        mEnrolleesData.GpsCount = lCount;
        if (isNullOrUndefined(mEnrolleesData.VictimSecondaryCurrentId)) {
            lTrackpointCountDetail = lEnrollee.FullName;
        }
        else {
            lTrackpointCountDetail = 'Total';
        }
        lTrackpointCountDetail += ': ' + lCount.toString() + ' GPS Points';
        if (lVisitCount.Count == 1 && lTrackPointCount == 0 && lVisitCount.InProgress) {
            lTrackpointCountDetail += ' (Current Visit)';
        }
        if (lTrackTypeValue === 1 && veritracks.enrollees.mapping.data.DisplayVisitCount) {
            lTrackpointCountDetail += ', ' + lVisitCount.Count + ' Visit';
            if (lVisitCount !== 0) {
                lTrackpointCountDetail += 's';
            }
        }

        $('#uEnrolleeTrackPointCount').html(lTrackpointCountDetail).show();

        if (lValue.length === 0) {
            $('#uShowVictimTrackpointsButton').addClass('Selected');
            $('#uShowVictimTrackPointEventsButton').addClass('Selected');
        } else {
            if (lValue.indexOf('5') === -1) {
                $('#uShowVictimTrackpointsButton').removeClass('Selected');
            } else {
                $('#uShowVictimTrackpointsButton').addClass('Selected');
            }
            if (lEnrollee.InMyOrganization) {
                if (lValue.indexOf('20') === -1) {
                    $('#uShowVictimTrackPointEventsButton').removeClass('Selected');
                } else {
                    $('#uShowVictimTrackPointEventsButton').addClass('Selected');
                }
            } else
                $('#uShowTrackPointEventsButton').hide();
        }

        $(window).resize();
        writeUserPreferences(aSender.FilterState);
        $('#uMapPlaybackPanel').show();

        if (aSender.Id == "uVictimTrackpointDetailCardViewFilter") {
            var ltrackallCount = CalculateAllPlaybackTracksPoints();
            if (ltrackallCount > 0) {
                mEnrolleesControls.PlaybackControl.Activate(true);
                uEnrolleesMapPlaybackLock();
            } else {
                mEnrolleesControls.PlaybackControl.Activate(false);
                uEnrolleesMapPlaybackLock();
            }
        }
    }, veritracks.enrollees.mapping.IconsGenerateOnFail, null, !lIsInformatics);
    
};

Victim.enrolleesVictimMap_Init = function () {
    "use strict";
    var lCard,
        lBuilder = new SumoPredicateBuilder(),
        lContactDateTimeSpan,
        lContactDateTime,
        lTrackDateTime,
        lOldDate,
        lContact = gEnrolleeLastContact[mEnrolleesData.VictimCurrentId];

    if (mEnrolleesData.VictimProfileCurrent && mEnrolleesData.VictimCurrentId == mEnrolleesData.VictimProfileCurrent.Id) {
        if ($('#uAddVictimsecondaryButton').hasClass('Selected')) {
            var EnrolleeId = mEnrolleesData.VictimProfileCurrent[mEnrolleesData.VictimProfileCurrent.SamaAssociateEnrolleeId?'SamaAssociateEnrolleeId':'OffenderId'];
            mEnrolleesData.VictimSecondaryCurrentId = EnrolleeId;
        }
        else {
            mEnrolleesData.VictimSecondaryCurrentId = null;
            $('#uAddVictimsecondaryButton').removeClass('Selected');
        }
    }
    else {
        mEnrolleesData.VictimSecondaryCurrentId = null;
        $('#uAddVictimsecondaryButton').removeClass('Selected');
    }

    if (!veritracks.enrollees.mapping.data.IsLocked) {
        lOldDate = new Date();
        lOldDate.addYears(-10);
        lCard = mEnrolleesControls.CardView.selectedDataItem();
        //lTrackDateTime = lCard.LastTrackpointDate;
        //lContactDateTime = lCard.LastContactDate;
        if (lCard.Enrollee.IsAssigned) {
            if (isNullOrUndefined(lContact)) {
                lTrackDateTime = getMoment();
                lContactDateTime = getMoment();
            } else {
                lTrackDateTime = lContact.TrackDate;
                lContactDateTime = lContact.ContactDate;
            }
            lContactDateTimeSpan = getMoment(lContactDateTime);

            // if contact is really old or trackdate is more than a year older than contact date
            lContactDateTimeSpan.addYears(-1);
            if (lContactDateTime < lOldDate || lContactDateTimeSpan > lTrackDateTime) {
                lTrackDateTime = getMoment();
            }
            mEnrolleesData.MapEndDate = displayEventInEnrolleeTimeZone(lTrackDateTime, lCard.Enrollee);
        }
    }
    if (!veritracks.enrollees.mapping.data.IsLocked && !lCard.Enrollee.IsAssigned && isNullOrUndefined(mEnrolleesData.secondLockDate)) {
        var lSort = new SortExpression();
        lSort.addDescendingColumn('ContactDate');
        lBuilder.AddNewExpressionConditional('EnrolleeId', mEnrolleesData.VictimCurrentId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        ReadMultiple(gObjectList.EnrolleeContactHistory.AssemblyQualifiedName, lBuilder.RootExpression, 0, VictimContact_OnComplete, null, null, lSort, 0);
    } else {
        if (veritracks.enrollees.mapping.data.IsLocked) {
            mEnrolleesData.MapEndDate = getMoment(mEnrolleesData.LockFeatureEndSaveState);
        }
        if (!isNullOrUndefined(mEnrolleesData.secondLockDate)) {
            mEnrolleesData.MapEndDate = getMoment(mEnrolleesData.secondLockDate);
            mEnrolleesData.secondLockDate = null;
            mEnrolleesData.secondLockOnEnrolleeId = null;
        }
        Victim.victimMapPopulate();
        if (!isNullOrUndefined(mEnrolleesData.VictimSecondaryCurrentId)) {
            offenderSecondaryVictimMapPopulate();
        }
    }

    function VictimContact_OnComplete(aParams, aContactList) {
        if (ObjectLength(aContactList) > 0) {
            var lContact,
                lTestDate;
            FixDates(aContactList);
            lContact = aContactList[0];
            lTestDate = getMoment(lContact.TrackDate);
            if (lContact.ContactDate > lTestDate.addYears(1) || isNaN(lTestDate)) {
                lContact.TrackDate = lContact.ContactDate;
            }
            mEnrolleesData.MapEndDate = getMoment(lContact.TrackDate);
        }
        else {
            mEnrolleesData.MapEndDate = new Date();
        }
        Victim.victimMapPopulate();
        if (!isNullOrUndefined(mEnrolleesData.VictimSecondaryCurrentId)) {
            offenderSecondaryVictimMapPopulate();
        }
    }
}


Victim.victimMapPopulate = function() {
    "use strict";
    var lContact = gEnrolleeLastContact[mEnrolleesData.victimCurrentId],
        lDateRange = VictimMapPopulate_GetDateRange(),
        lTripStartDate = lDateRange.startDate,
        lTripEndDate = lDateRange.endDate,
        lTrackDate,
        lState,
        lUserChange = false,
        lStartDateFilterEditable = veritracks.system.clientSetting('StartDateFilterEditable'),
        lUpdateFlag = false,
        lVictim = getDataItem(mEnrolleesData.VictimCurrentId, 'Enrollees');

    if (!isNullOrUndefined(arguments[0]))
        lUserChange = arguments[0];

    if (isNullOrUndefined(lVictim)) {
        lVictim = getDataItem(mEnrolleesData.VictimCurrentId, 'EnrolleesUniversal');
    }

    if (!lVictim.InMyOrganization) {
        $('#uEnrolleesPrintButton').hide();
        $('#uShowTrackPointEventsButton').hide();
    }
    else {
        $('#uEnrolleesPrintButton').show();
        $('#uShowTrackPointEventsButton').show();
    }

    $('#uRefreshButton').removeClass('RefreshYesButton');
    $('#uRefreshButton').addClass('RefreshNoButton');
    $('#uRefreshButton').attr('title', 'refesh not available');

    function onReplace(aId) {
    }

    if (!isNullOrUndefined(mEnrolleesControls.NotificationPanel)) {
        mEnrolleesControls.NotificationPanel.clearNotifications();
    }
    if (!isNullOrUndefined(mEnrolleesControls.VictimTrackpointDetailCardView)) {
        mEnrolleesControls.VictimTrackpointDetailCardView.setDataSource([]);
        mEnrolleesControls.EnrolleesMap.layerSetDataSource('Selected', []);
        mEnrolleesControls.EnrolleesMap.layerSetDataSource('Addresses', []);
        mEnrolleesControls.EnrolleesMap.layerSetDataSource('Zones', []);
        mEnrolleesControls.EnrolleesMap.layerSetDataSource('LargeZones', []);
        mEnrolleesControls.EnrolleesMap.layerSetDataSource('Visits', []);

        mEnrolleesControls.EnrolleesMap.layerSetDataSource('Tags', []);
        mEnrolleesControls.EnrolleesMap.layerSetDataSource('TagLabels', []);
        mEnrolleesControls.EnrolleesMap.layerSetDataSource('ZonesNames', []);
        //mEnrolleesControls.EnrolleesMap.layerSetDataSource('Visits', []);
        mEnrolleesControls.EnrolleesMap.layerSetDataSource('SecondaryVisits', []);
        mEnrolleesControls.EnrolleesMap.layerSetDataSource('ConnectedTracks', []);
        mEnrolleesControls.EnrolleesMap.layerSetDataSource('SecondaryConnectedTracks', []);
        mEnrolleesControls.EnrolleesMap.layerSetDataSource('Labels', []);

        victim_toggleuLastContactButton();


        if (mEnrolleesData.PlaybackStatus !== 'Stopped') {
            uEnrolleesMapPlaybackStopButton_OnClick();
        }
        //victimCollapseVisitButton_OnClick();
        //veritracks.enrollees.mapping.collapseVisits(false);
    }
    if (isNullOrUndefined(mEnrolleesControls.PrimaryEnrolleeTimer))
        mEnrolleesControls.PrimaryEnrolleeTimer = new TimerManager(500);

    mEnrolleesControls.PrimaryEnrolleeTimer.SetTimer(function (aParams) {
        lState = getViewState('AnalysisMatchEndDate');
        var lEnrollee = getDataItem(mEnrolleesData.VictimCurrentId, 'Enrollees'),
            lCardContact = mEnrolleesControls.CardView.selectedDataItem();

        if (isNullOrUndefined(lEnrollee)) {
            lEnrollee = getDataItem(mEnrolleesData.VictimCurrentId, 'EnrolleesUniversal');
        }

        if (!isNullOrUndefined(lState) && !isNullOrUndefined(lState.Value)) {
            mEnrolleesData.MapEndDate = lState.Value;
            lDateRange = VictimMapPopulate_GetDateRange();
            lTripStartDate = lDateRange.startDate;
            lTripEndDate = lDateRange.endDate;
            setViewState('AnalysisMatchEndDate', null);
            setViewState('TravelBackFromEnrolleesTile', true);
        } else {
            var lSpatialState = getViewState('AnalysisSpatialMatchEndDate');
            if (!isNullOrUndefined(lSpatialState)) {
                mEnrolleesData.MapEndDate = lSpatialState.Value;
                lDateRange = VictimMapPopulate_GetDateRange();
                lTripStartDate = lDateRange.startDate;
                lTripEndDate = lDateRange.endDate;
                deleteViewState('AnalysisSpatialMatchEndDate');
            }
        }

        if (lStartDateFilterEditable) {
            $('#uMapStartDatePicker').val(displayShortDate(lTripStartDate));
            $('#uMapStartTimePicker').val($.format.date(lTripStartDate, "h:mm a"));
            $('#uMapEndDate').html(DisplayShortDateTime(lTripEndDate));
        } else {
            $('#uMapStartDate').html(DisplayShortDateTime(lTripStartDate));
            $('#uMapDatePicker').val(displayShortDate(lTripEndDate));
            $('#uMapTimePicker').val($.format.date(lTripEndDate, "h:mm a"));
        }
        lTripStartDate = FixSentDate(lTripStartDate, lVictim);
        lTripEndDate = FixSentDate(lTripEndDate, lVictim);

        if (!isNullOrUndefined(lContact) && lVictim.IsAssigned) {
            lTrackDate = new Date(lContact.TrackDate);
            //if (mEnrolleesControls.CardView.isUpdateVisible()) {
            //    lTrackDate = lTrackDate.addMinutes(-30);
            //}
            lUpdateFlag = (+lTrackDate == +mEnrolleesData.MapEndDate) ? true : false;
        } else {
            lTrackDate = new Date(0);
        }
        // dont allow credit for user on future dates
        if (moment(lTripStartDate) < moment())
            logUserTransaction(mEnrolleesData.VictimCurrentId, 1, 1, lTripStartDate, lTripEndDate, lTrackDate);


        veritracks.enrollees.mapping.initialize(mEnrolleesData.VictimCurrentId, 1, lTripStartDate, lTripEndDate, lUpdateFlag);
        var lNextDay = victimMapPopulateNextDay_GetDateRange();
        if (lNextDay.IsValid && !lUpdateFlag)
            veritracks.enrollees.mapping.initializeNextDay(mEnrolleesData.VictimCurrentId, 1, lNextDay.startDate, lNextDay.endDate);

    }, {}, onReplace);
}

Victim.uVictimMap_Init = function() {
    "use strict";
    // uTrackpointDetailCardViewFilter_OnFilter();
    var lUserPreferences = getUserPreferences(4),
        lSystemPreferences = getUserPreferences(10),
        lDisplayType = 'roadmap',
        lPermission = gUserPermissions[19],
        lParams,
        lBuilder,
        lFilterList = gMapFilterList,
        lUnavailableItems = ['1','2', '3', '4', '6'],
        lDoDisplayCellPoints = veritracks.system.clientSetting('MapDisplayCellCentroids'),
        lDefaultCriteria = ['1', '2', '3', '5', '20', '8'],
        lStartDateFilterEditable = veritracks.system.clientSetting('StartDateFilterEditable');

    if (isNullOrUndefined(lPermission) || lPermission.Value == 0) {
        lUnavailableItems.push('6');
    }
    if (!lDoDisplayCellPoints) {
        lUnavailableItems.push('9');
    }
    if (lUnavailableItems.length > 0) {
        lBuilder = new SumoPredicateBuilder();
        lBuilder.AddNewExpressionConditional('Id', lUnavailableItems, false, mRelationalOperatorEnum.NotIn(), mLogicalOperatorEnum.And());
        lFilterList = query(lFilterList, lBuilder.RootExpression);
    }
    if (gUserDetails.Role !== 2) {
        lFilterList.push({ 'Id': '20', 'Title': 'Trackpoint Events' });
    }

    lParams = {
        'Title': 'Find Map Objects',
        'Content': '',
        'CssClass': 'DefaultFilter',
        'HideOnFilter': true,
        'OnFilter': Victim.mapping_filter,
        'Columns': [
                { 'Id': 'TypeVictim', 'Title': 'Display', 'Type': 'CheckList', 'DataField': 'Type', 'DataSource': lFilterList, 'DataTextField': 'Title', 'DataValueField': 'Id', 'DefaultValue': lDefaultCriteria }
        ],
        'Settings': null,
        'UserPreferences': lUserPreferences,
        'UserId': gUserDetails.UserId,
        'UserPreferenceType': 4
    };
    mEnrolleesControls.VictimTrackpointDetailCardViewFilter = gFilterFactory.createControl('uVictimTrackpointDetailCardViewFilter', 'uVictimTrackpointDetailCardViewFilterHolder', lParams);
    if (!isNullOrUndefined(lSystemPreferences['MapDisplayType'])) {
        lDisplayType = lSystemPreferences['MapDisplayType'].Value;
    }
    mEnrolleesControls.EnrolleesMap = new sumo.maps.GoogleMapControl('uVictimMap', 'uMapPanel', { 'displayType': lDisplayType, 'mapTypeId_OnChange': mapDisplayType_OnChange, 'OnClick': veritracks.enrollees.mapping.onClick });
    mEnrolleesControls.VictimTrackpointDetailCardView = new sumo.controls.CardView('uTrackpointDetailCardView', 'uTrackpointDetailCardViewHolder', {
        'cardTemplate': 'Interface/Enrollees.Victims.Map.Card.Template.htm', 'selectMethod': 'single', 'canUnselect': true, 'cssClass': 'VeritracksCardView', 'keyField': 'Id', 'isSortable': false, 'Columns': [
            { 'id': 'SortDate', 'title': 'Sort Date' },
            { 'id': 'EnrolleeFirstName', 'title': 'First Name' },
            { 'id': 'EnroleeLastName', 'title': 'Last Name' }
        ],
        'IgnoreOnClick': 'StreetViewIcon'
    });

    mEnrolleesControls.VictimTrackpointDetailCardView.bind('selectedchanged', uTrackpointDetailCardView_OnSelectChange);
    mEnrolleesControls.EnrolleesMap.bind('streetviewerror', showStreetViewError);

    var lLayerOptions = {
        'renderType': 'marker',
        'doesPlayback': true,
        'isVisible': true,
        'clickEventHandler': veritracks.mapping.enrolleeMarkerClick,
        'hoverEventHandler': veritracks.mapping.enrolleeMarkerHover,
        'hoverOutEventHandler': veritracks.mapping.enrolleeMarkerHoverOut,
        'zIndexStart': 90000
    },
    lIsCaseLoadVisible = false,
    lUserPreferences = getUserPreferences(4);
    if (!isNullOrUndefined(lUserPreferences['IsCaseLoadVisible'])) {
        lIsCaseLoadVisible = (lUserPreferences['IsCaseLoadVisible'].Value === 'true');
    }
    mEnrolleesControls.EnrolleesMap.layerAdd('Visits', lLayerOptions);

    var lLayerOptions = {
        'renderType': 'marker',
        'doesPlayback': true,
        'isVisible': true,
        'clickEventHandler': veritracks.mapping.enrolleeMarkerClick,
        'zIndexStart': 90000
    },
lIsCaseLoadVisible = false,
lUserPreferences = getUserPreferences(4);
    if (!isNullOrUndefined(lUserPreferences['IsCaseLoadVisible'])) {
        lIsCaseLoadVisible = (lUserPreferences['IsCaseLoadVisible'].Value === 'true');
    }
    mEnrolleesControls.EnrolleesMap.layerAdd('SecondaryVisits', lLayerOptions);

    lLayerOptions = {
        'renderType': 'label',
        'doesPlayback': true,
        'isVisible': true,
        'clickEventHandler': null,
        'zIndexStart': 85000
    };
    mEnrolleesControls.EnrolleesMap.layerAdd('Labels', lLayerOptions);

    lLayerOptions = {
        'renderType': 'marker',
        'doesPlayback': false,
        'isVisible': true,
        'zIndexStart': 120000,
        'dragEndEventHandler': function (aEvent, aMarker) {
            var lLatLong = { 'Latitude': aMarker.latLng.lat(), 'Longitude': aMarker.latLng.lng() };
            populateEditView(lLatLong, [], {}, 'uMapTag', 'Edit');
        }
    };
    mEnrolleesControls.EnrolleesMap.layerAdd('TagEdit', lLayerOptions);

    lLayerOptions = {
        'renderType': 'marker',
        'doesPlayback': false,
        'isVisible': true,
        'clickEventHandler': veritracks.mapping.enrolleeMarkerClick,
        'zIndexStart': 60000
    };
    mEnrolleesControls.EnrolleesMap.layerAdd('Addresses', lLayerOptions);

    lLayerOptions = {
        'renderType': 'marker',
        'doesPlayback': false,
        'isVisible': true,
        'clickEventHandler': null,
        'zIndexStart': 80000,
        'markerImageSize': { 'width': 32, 'height': 32 }
    };
    mEnrolleesControls.EnrolleesMap.layerAdd('Tags', lLayerOptions);

    mEnrolleesControls.EnrolleesMap.layerAdd('TagLabels', {
        'renderType': 'label',
        'doesPlayback': false,
        'isVisible': true,
        'clickEventHandler': null,
        'zIndexStart': 700000
    });
    //mEnrolleesControls.EnrolleesMap.layerAdd('LargeZones', {
    //    'renderType': 'geometry',
    //    'doesPlayback': false,
    //    'isVisible': true,
    //    'clickEventHandler': ignoreme,
    //    'zIndexStart': 1000000,
    //    'shapeChangeHandler': VictimZoneMapShape_OnChange
    //});

    //mEnrolleesControls.EnrolleesMap.layerAdd('Zones', {
    //    'renderType': 'geometry',
    //    'doesPlayback': false,
    //    'isVisible': true,
    //    'clickEventHandler': ignoreme,
    //    'zIndexStart': 1000000,
    //    'shapeChangeHandler': VictimZoneMapShape_OnChange
    //});

    //mEnrolleesControls.EnrolleesMap.layerAdd('ZonesNames', {
    //    'renderType': 'label',
    //    'doesPlayback': false,
    //    'isVisible': true,
    //    'clickEventHandler': null,
    //    'zIndexStart': 1300000
    //});

    mEnrolleesControls.EnrolleesMap.layerAdd('Selected', {
        'renderType': 'marker',
        'doesPlayback': false,
        'isVisible': true,
        'clickEventHandler': null,
        'zIndexStart': 1200000
    });

    mEnrolleesControls.EnrolleesMap.layerAdd('SuggestionLabels', {
        'renderType': 'label',
        'doesPlayback': false,
        'isVisible': true,
        'clickEventHandler': null,
        'zIndexStart': 1300000
    });

    mEnrolleesControls.EnrolleesMap.layerAdd('Suggestions', {
        'renderType': 'marker',
        'doesPlayback': false,
        'isVisible': true,
        'clickEventHandler': null,
        'zIndexStart': 1400000
    });

    mEnrolleesControls.EnrolleesMap.layerAdd('CaseLoadLabels', {
        'renderType': 'label',
        'doesPlayback': false,
        'isVisible': lIsCaseLoadVisible,
        'clickEventHandler': null,
        'zIndexStart': 1500000
    });

    mEnrolleesControls.EnrolleesMap.layerAdd('CaseLoad', {
        'renderType': 'marker',
        'doesPlayback': false,
        'isVisible': lIsCaseLoadVisible,
        'clickEventHandler': null,
        'zIndexStart': 1600000
    });

    //lLayerOptions = {
    //    'renderType': 'marker',
    //    'doesPlayback': false,
    //    'isVisible': true,
    //    'clickEventHandler': enrolleesVictimPlacesMarker_OnClick,
    //    'zIndexStart': 60000,
    //    'markerImageSize': { 'width': 32, 'height': 32 }
    //};
    mEnrolleesControls.EnrolleesMap.layerAdd('Places', lLayerOptions);

    mEnrolleesControls.EnrolleesMap.layerAdd('DistancePoints', {
        'renderType': 'marker',
        'doesPlayback': false,
        'isVisible': true,
        'clickEventHandler': null,
        'zIndexStart': 1300000,
        'markerImageSize': { 'width': 32, 'height': 32 }
    });

    mEnrolleesControls.EnrolleesMap.layerAdd('DistanceLabels', {
        'renderType': 'label',
        'doesPlayback': false,
        'isVisible': true,
        'clickEventHandler': null,
        'zIndexStart': 2000000
    });

    mEnrolleesControls.EnrolleesMap.layerAdd('ConnectedDistancePoints', {
        'renderType': 'linesegment',
        'doesPlayback': true,
        'isVisible': true,
        'isClickable': false,
        'clickEventHandler': null,
        'zIndexStart': 700000
    });

    mEnrolleesControls.EnrolleesMap.layerAdd('HomePoints', {
        'renderType': 'marker',
        'doesPlayback': false,
        'isVisible': true,        
        'clickEventHandler': null,
        'zIndexStart': 3300000,
        'markerImageSize': { 'width': 32, 'height': 32 }
    });


    lLayerOptions = {
        'renderType': 'linesegment',
        'doesPlayback': true,
        'isVisible': true,
        'isClickable': false,
        'clickEventHandler': null,
        'zIndexStart': 10000
    };
    mEnrolleesControls.EnrolleesMap.layerAdd('ConnectedTracks', lLayerOptions);

    lLayerOptions = {
        'renderType': 'linesegment',
        'doesPlayback': true,
        'isVisible': true,
        'isClickable': false,
        'clickEventHandler': null,
        'zIndexStart': 10000,
        'lineSegmentColor': 'purple'
    };
    mEnrolleesControls.EnrolleesMap.layerAdd('SecondaryConnectedTracks', lLayerOptions);

    mEnrolleesControls.PlaybackControl = mEnrolleesControls.EnrolleesMap.getPlaybackController('Visits', {
        'speedControls': {
            'keyProperty': 'TrackTypeId',
            'values': [
            {
                'value': 1,
                'speedMultiplier': 1
            }, {
                'value': 2,
                'speedMultiplier': 1
            }, {
                'value': 3,
                'speedMultiplier': 1
            }, {
                'value': 'undefined',
                'speedMultiplier': 4
            }]
        }
    });

    mEnrolleesControls.PlaybackControl.bind('statechange', enrolleePlaybackControl_OnSelectChange);
    //mEnrolleesControls.PlaybackControl = mEnrolleesControls.EnrolleesMap.getPlaybackController('SecondaryVisits');
    $('#uSlider').slider({ 'min': 0, 'max': 99, 'slide': slider_OnSlide });
    mEnrolleesControls.PlaybackControl.bind('progressed', uEnrolleesMapPlayback_OnProgressed);
    mEnrolleesControls.PlaybackControl.bind('completed', uEnrolleesMapPlayback_OnCompleted);


    if (lStartDateFilterEditable) {
        populateDateView('#uMapStartDatePicker', enrolleesOffendersMapStartDateTime_OnChange);
        $('#uMapStartTimePicker').ptTimeSelect({
            'zIndex': 100000,
            'onFocusDisplay': true,
            'onClose': enrolleesOffendersMapStartDateTime_OnChange
        });
        $('.MapStartDateFilter').show();
        $('.MapEndDateFilter').hide();
    } else {
        $('.MapStartDateFilter').hide();
        $('.MapEndDateFilter').show();
    }
    populateDateView('#uMapDatePicker', enrolleesOffendersMapDateTime_OnChange);
    $('#uMapTimePicker').ptTimeSelect({
        'zIndex': 100000,
        'onFocusDisplay': true,
        'onClose': enrolleesOffendersMapDateTime_OnChange
    });

}
Victim.uVictimsCardViewFilter_Init = function() {
    "use strict";
    var lUserPreferences = getUserPreferences(2);
    mEnrolleesData.TargetId = -1;
        if (isNullOrUndefined(mEnrolleesControls.CardViewVictimFilter)) {
            var lParams = {
                'Title': localizeWrapper('cEnrolleeFindVictims'),
                'Content': '',
                'CssClass': 'DefaultFilter',
                'HideOnFilter': true,
                'OnFilter': Victim.uVictimsCardViewFilter_OnFilter,
                'Columns': [
                    { 'Id': 'FullName', 'Title': localizeWrapper('cEnrolleeName'), 'Type': 'Text', 'DataField': 'FullName' },
                    { 'Id': 'PrimaryID', 'Title': localizeWrapper('cEnrolleePrimaryId'), 'Type': 'Text', 'DataField': 'PrimaryId' },
                    { 'Id': 'AgentName', 'Title': localizeWrapper('cAgent'), 'Type': 'Text', 'DataField': 'AgentName' },
                    { 'Id': 'IsAssigned', 'Title': localizeWrapper('cEnrolleeIsAssigned'), 'Type': 'Dropdown', 'DataField': 'IsAssigned', 'DataSource': [{ 'Value': true, 'Text': localizeText('cYes') }, { 'Value': false, 'Text': localizeText('cNo') }], 'DataValueField': 'Value', 'DataTextField': 'Text', 'DefaultValue': false, 'ComparisonType': 'Boolean', 'InsertBlank': true, 'BlankText': localizeText('cBoth') }
                ],
                'Settings': null,
                'UserPreferences': lUserPreferences,
                'UserId': gUserDetails.UserId,
                'UserPreferenceType': 2
            };
            mEnrolleesControls.CardViewVictimFilter = gFilterFactory.createControl('uVictimsCardViewFilter', 'uEnrolleesListFilterHolder', lParams);
        } else {
            mEnrolleesControls.CardViewVictimFilter.render();
        }
}
Victim.uVictimsCardViewPaginator_Init = function() {
    "use strict";
    if (isNullOrUndefined(mEnrolleesControls.CardViewVictimPaginator)) {
        mEnrolleesControls.CardViewVictimPaginator = new sumo.controls.Paginator('uVictimsCardViewPaginator', 'uEnrolleesPagerHolder', {
            'ItemCount': count(mEnrolleesData.VictimDirty),
            'ItemsPerPage': gPaginationSettings.EnrolleesVictimsItems
        });
        //mEnrolleesControls.CardViewVictimPaginator = gPaginatorFactory.createControl('uVictimsCardViewPaginator', 'uEnrolleesPagerHolder', {
        //'ItemCount': count(mEnrolleesData.VictimDirty),
        //'ItemsPerPage': 500000
        //});
        mEnrolleesControls.CardViewVictimPaginator.bind('pagechanged', Victim.uVictimsPaginator_OnPageChanged);
    } else {
        mEnrolleesControls.CardViewVictimPaginator.render();
    }
    mEnrolleesControls.CardViewVictimFilter.filter();
}

Victim.uVictimsList_OnSelectChange = function () {
    mEnrolleesData.VictimCurrentId = aEnrolleeId;
    Victim.victimProfilePopulate();
    window['mStateManagerEnrolleesSecondary' + mStateManager.Settings()[2] + '_Init']();
}

Victim.victimProfilePopulate = function(aId) {
    "use strict";
    mStateManager.ChangeSettings(2,'Events');

    var VictimCurrentId = aId?aId:mEnrolleesData.VictimCurrentId;
    mEnrolleesData.VictimSecondaryCurrentId = null;
    mEnrolleesData.VictimProfileCurrent = new VictimProfile(VictimCurrentId);
    VictimController.showLoading();
    mEnrolleesData.VictimProfileCurrent.Read(function(aParams, aData) {
        if (!isNullOrUndefined(aData)) {
            FixDates(aData);
            VictimController.Render();
            if (mStateManager.Settings()[2] == 'Notifications'){
                window['EnrolleeProfile' + mStateManager.Settings()[2] + '_Init']();
            }
        }
        VictimController.hideLoading();
        //TODO: Add validation to StalkerController.OnChange
    //     uSAMARegistration.Render(mEnrolleesData.VictimProfileCurrent);
    //     VictimController.hideLoading();
    });
}

Victim.victimEnrolleePopulate = function(aId) {
    "use strict";
    var lVictim = GetEnrollee(aId);
    PopulateDetailView(lVictim, {
        'AgentId': AgentNameFormatter,
        'OrganizationId': OrganizationNameFormatter,
        'Birthdate': BirthDateStringFormatter,
    }, 'uEnrolleeProfile');
}

// Victim.victimProfileRead_OnComplete = function(aParams, aData) {
//     "use strict";
//     if (aParams === mEnrolleesData.VictimCurrentId && !isNullOrUndefined(aData[0])) {
//         FixDates(aData);
//         mEnrolleesData.VictimProfileCurrent = aData[0];
//         var lOffender = getDataItem(mEnrolleesData.VictimProfileCurrent.OffenderId, 'Enrollees');
//         Victim.victimEnrolleePopulate(mEnrolleesData.VictimProfileCurrent.Id);
//         PopulateDetailView(mEnrolleesData.VictimProfileCurrent, {
//             'TimeZoneCode': timezoneCodeFormatter,
//             'VictimId': EnrolleeNameFormatter
//         }, 'uVictimProfile');
//         if(lOffender)
//             $('#uVictimProfileOffenderId').text(lOffender.FullName + ' (' + lOffender.PrimaryId + ')');
//         else
//             $('#uVictimProfileOffenderId').text('');
//         if (mStateManager.Settings()[2] == 'Notifications')
//             window['EnrolleeProfile' + mStateManager.Settings()[2] + '_Init']();
//     }
//     uSAMARegistration.Render(mEnrolleesData.VictimProfileCurrent);
// }

Victim.victimProfileRead_OnFailure = function(a, b, c) {
    "use strict";
}

Victim.PopulateVictimMap = function() {
    "use strict";
    $('#uEnrolleesMapPanel').text(mEnrolleesData.VictimCurrentId);
}

Victim.VictimZoneMapShape_OnChange = function(aShape) {
    "use strict";
    if (mEnrolleesData.OffenderZoneEdit.Shape === 1) {
        mEnrolleesData.OffenderZoneEdit.CenterLatitude = aShape.center.lat();
        mEnrolleesData.OffenderZoneEdit.CenterLongitude = aShape.center.lng();
        mEnrolleesData.OffenderZoneEdit.Radius = sumo.geo.conversion.metersToFeet(aShape.radius);
    } else {
        var lCenter = aShape.getCenter();
        mEnrolleesData.OffenderZoneEdit.CenterLatitude = lCenter.lat();
        mEnrolleesData.OffenderZoneEdit.CenterLongitude = lCenter.lng();
    }
}

Victim.enrolleesVictimMapTimeFilter_Onchange = function() {
    "use strict";
    var lStartDateFilterEditable = veritracks.system.clientSetting('StartDateFilterEditable');

    //mEnrolleesData.OffenderPastData = null;
    veritracks.enrollees.mapping.data.VisitCardList = [];
    veritracks.enrollees.mapping.data.VisitsProcesssed = false;

    if (lStartDateFilterEditable) {
        var lTimeFilter = parseInt($('#uEnrolleeMapTimeFilter').val()),
            lStartDate = $('#uMapStartDatePicker').val(),
            lStarTime = $('#uMapStartTimePicker').val(),
            lValue = lStartDate + ' ' + lStarTime,
            lDate = new Date(lValue);

        mEnrolleesData.MapEndDate = lDate.addMinutes(lTimeFilter);
    }
    veritracks.enrollees.mapping.initializeEnrolleeMap();
}

// Device Assignments
function uEnrolleesAddVictimAssignment_OnClick() {
    "use strict";
    var lBuilder = new SumoPredicateBuilder(),
        lDevicesOffenders,
        lAssigned,
        lAssignedId,
        lCurrentOffenderId = mEnrolleesData.VictimProfileCurrent.OffenderId,
        lEnrollee = getDataItem(mEnrolleesData.VictimProfileCurrent.Id, 'Enrollees'),
        lSort = new SortExpression(),
        lAssignableOffenders = [];

    mEnrolleesData.VictimAssignableOffenders = [];

    if (lEnrollee.PrimaryId) {
        lBuilder.AddNewExpressionConditional('EnrolleeType', 1, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        lBuilder.AddNewExpressionConditional('HasVictimFlag', false, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        lBuilder.AddNewExpressionConditional('OrganizationId', lEnrollee.OrganizationId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        lAssignableOffenders = query(getDataItems('Enrollees'), lBuilder.RootExpression);

        lBuilder.Clear();
        lBuilder.AddNewExpressionConditional('IsAssigned', true, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        lBuilder.AddNewExpressionConditional('HasVictimFlag', false, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        lBuilder.AddNewExpressionConditional('OrganizationId', lEnrollee.OrganizationId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        lAssigned = getArrayByIds(query(getDataItems('Enrollees'), lBuilder.RootExpression));

        lBuilder.Clear();
        lBuilder.AddNewExpressionConditional('EnrolleeId', lAssigned, false, mRelationalOperatorEnum.In(), mLogicalOperatorEnum.And());
        lBuilder.AddNewExpressionConditional('OrganizationId', lEnrollee.OrganizationId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        lBuilder.AddNewExpressionConditional('ProductId', [103, 151], false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        lDevicesOffenders = query(getDataItems('CurrentDeviceAssignments'), lBuilder.RootExpression);

        for (var lKey in lDevicesOffenders) {
            if (lDevicesOffenders.hasOwnProperty(lKey)) {
                var lEnrollee = getDataItem(lDevicesOffenders[lKey].EnrolleeId, 'Enrollees');
                lAssignableOffenders.push(lEnrollee);
            }
        }

        if (lCurrentOffenderId > 0) {
            var lCurrentOffender = getDataItem(lCurrentOffenderId, 'Enrollees');
            //if (lCurrentOffender.OrganizationId !== mEnrolleesData.VictimProfileCurrent.OrganizationId) {
                lAssignableOffenders.push(lCurrentOffender);
            // }
        }


        lSort.addAscendingColumn('FullName');
        mEnrolleesData.VictimAssignableOffenders = lSort.sort(lAssignableOffenders);


        offenderScheduleConfiguration_Init(mEnrolleesData.VictimCurrentId);
        mEnrolleesData.VictimEnrollment = new OffenderDeviceEnrollment(gUserDetails.UserId, mEnrolleesData.VictimCurrentId);

        mEnrolleesControls.DeviceAssignmentsWizard = new sumo.controls.Wizard('uDeviceAssignmentsWizard', 'uWizardHolder', {
            'steps': [
                { 'fileName': 'Interface/Enrollees.Offenders.Profile.Assignments.Wizard/VictimsDevice.html', 'allowSave': false, 'hidden': false, 'pageTitle': 1 },
                { 'fileName': 'Interface/Enrollees.Offenders.Profile.Assignments.Wizard/VictimRadius.html', 'allowSave': true, 'hidden': false, 'pageTitle': 2 }
            ],
            'FixPages': { 'UseSkip': false, 'AddOne': 2, 'SubtractOne': 4 },
            'HidablePage': 3

        });
        $('#uWizardHolder').show();
        mEnrolleesControls.DeviceAssignmentsWizard.bind('changing', uVictimsDeviceAssignmentsWizard_OnChanging);
        mEnrolleesControls.DeviceAssignmentsWizard.bind('changed', uVictimsDeviceAssignmentsWizard_OnChanged);
        mEnrolleesControls.DeviceAssignmentsWizard.bind('save', uVictimsDeviceAssignmentsWizard_OnSave);
        mEnrolleesControls.DeviceAssignmentsWizard.bind('close', uVictimsDeviceAssignmentsWizard_OnClose);
    } else {
        displayVictimNotFinishedPopup();
    }
}

function uVictimsDeviceAssignmentsWizard_OnChanging(aSender, aStepId, aParams) {
    "use strict";
    var lSelected;
    switch (aStepId) {
        case 1:
            mEnrolleesControls.DeviceAssignmentsMap.dispose();
            mEnrolleesControls.DeviceAssignmentsMap = null;
            mEnrolleesControls.TrackingDeviceCardView.unbind('databind', uVictimsDeviceAssignmentsWizardTrackingDeviceCardView_OnRender);
            $('#uDeviceAssignmentsWizardTrackingSearch').unbind('keyup', uVictimDeviceAssignmentsWizardTrackingSearch_OnChange); //.unbind('change', uDeviceAssignmentsWizardTrackingSearch_OnChange)
            lSelected = mEnrolleesControls.TrackingDeviceCardView.selectedDataItem();
            if (!isNullOrUndefined(lSelected)) {
                mEnrolleesData.VictimEnrollment.TrackingDeviceId = lSelected.Id;
                mEnrolleesData.VictimEnrollment.TrackingDeviceType = lSelected.ProductId;
            }
            break;
    }
}

function uVictimsDeviceAssignmentsWizard_OnChanged(aSender, aStepId, aParams) {
    "use strict";
    var lDisplayType = 'roadmap',
        lSystemPreferences = getUserPreferences(10),
        lVictim = getDataItem(mEnrolleesData.VictimProfileCurrent.Id, 'Enrollees'),
        lBuilder,
        lColumns;

    switch (aStepId) {
        case 1:
            uVictimsDeviceAssignmentsWizardTab_OnClick('Map');

            if (!isNullOrUndefined(lSystemPreferences['MapDisplayType'])) {
                lDisplayType = lSystemPreferences['MapDisplayType'].Value;
            }
            mEnrolleesControls.DeviceAssignmentsMap = new sumo.maps.GoogleMapControl('uDeviceAssignmentsWizardMap', 'uDeviceAssignmentsWizardMapHolder', { 'displayType': lDisplayType, 'mapTypeId_OnChange': mapDisplayType_OnChange });
            mEnrolleesControls.DeviceAssignmentsMap.layerAdd('Contact', {
                'renderType': 'marker',
                'doesPlayback': true,
                'isVisible': true,
                'clickEventHandler': null,
                'zIndexStart': 90000
            });
            mEnrolleesControls.DeviceAssignmentsMap.layerAdd('Labels', {
                'renderType': 'label',
                'doesPlayback': true,
                'isVisible': true,
                'clickEventHandler': null,
                'zIndexStart': 800000
            });

            lColumns = [
                { 'id': 'ContactDate', 'title': localizeWrapper('cEnrolleeDateTime'), 'dataField': 'ContactDate', 'width': 'autoData', 'minWidth': 20, 'sortable': false, 'cssClass': null, 'formatMethod': DisplayShortDateTime },
                { 'id': 'Status', 'title': localizeWrapper('cEnrolleeStatus'), 'dataField': 'Status', 'width': 'autoData', 'minWidth': 36, 'sortable': false, 'cssClass': null, 'formatMethod': ContactStatusNameFormatter },
                { 'id': 'RecordCount', 'title': localizeWrapper('cEnrolleePoints'), 'dataField': 'RecordCount', 'width': 'autoData', 'minWidth': 36, 'sortable': false, 'cssClass': null, 'formatMethod': null },
                { 'id': 'GpsRecordCount', 'title': localizeWrapper('cInventoryGPS'), 'dataField': 'GpsRecordCount', 'width': 'autoData', 'minWidth': 25, 'sortable': false, 'cssClass': null, 'formatMethod': null },
                { 'id': 'PercentGps', 'title': localizeWrapper('cInventoryPercentGPS'), 'dataField': 'PercentGps', 'width': 'autoData', 'minWidth': 40, 'sortable': false, 'cssClass': null, 'formatMethod': DisplayPercent },
                { 'id': 'BatteryLevel', 'title': '', 'dataField': 'BatteryLevel', 'width': 'autoData', 'minWidth': 24, 'sortable': false, 'cssClass': 'CenterImage', 'formatMethod': inventoryBatteryLevelFormatter, 'canResize': false },
                { 'id': 'BatteryVoltage', 'title': '', 'dataField': 'BatteryVoltage', 'width': 'autoData', 'minWidth': 24, 'sortable': false, 'cssClass': 'CenterImage', 'formatMethod': DisplayVolts, 'canResize': false }
            ];

            mEnrolleesControls.DeviceAssignmentsContactList = new sumo.controls.ListView('uDeviceAssignmentsWizardListView', 'uDeviceAssignmentsWizardListViewHolder', { 'keyField': 'Id', 'selectMethod': 'none', 'cssClass': 'VeritracksListView', 'canUnselect': true }, lColumns);

            mEnrolleesControls.TrackingDeviceCardView = new sumo.controls.CardView('uDeviceAssignmentsWizardTrackingDeviceCardView', 'uDeviceAssignmentsWizardTrackingDeviceCardViewHolder', { 'cardTemplate': 'Interface/Enrollees.Offenders.Profile.Assignments.Popup.Tracking.Card.Template.htm', 'selectMethod': 'single', 'canUnselect': true, 'cssClass': 'VeritracksCardView', 'keyField': 'Id', 'keyFieldType': 'number' });
            mEnrolleesControls.TrackingDeviceCardView.bind('selectedchanged', uVictimsDeviceAssignmentsWizardTrackingDeviceCardView_OnSelectChange);
            mEnrolleesControls.TrackingDeviceCardView.bind('databind', uVictimsDeviceAssignmentsWizardTrackingDeviceCardView_OnRender);
            $('#uDeviceAssignmentsWizardTrackingSearch').keyup(uVictimDeviceAssignmentsWizardTrackingSearch_OnChange).keyup(); //.change(uDeviceAssignmentsWizardTrackingSearch_OnChange)
            $('.sumo-wizard-blade-command .sumo-wizard-save').hide();
            $('.sumo-wizard-blade-command .sumo-wizard-next').hide();
            break;
        case 2:
            lBuilder = new SumoPredicateBuilder();
            lBuilder.AddNewExpressionConditional('OrganizationId', lVictim.OrganizationId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
            lBuilder.AddNewExpressionConditional('EnrolleeType', 1, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
            
            var lSelectField = $('#uDeviceAssignmentWizardOffenderSelectEdit');
            lSelectField.select2({
                dropdownParent: $('#uDeviceAssignmentsWizard'),
            }).one('select2:open', function(e){
                $('.select2-search__field').attr('placeholder', localizeText('cEnterEnrollee'));
            });
            
            var lSelected = false;
            if (mEnrolleesData.VictimProfileCurrent.OffenderId == -1) {
                lSelected = true
            }
            mEnrolleesData.Validator = new Validator('uDeviceAssignmentsWizard2Content', mRegexValidation);

            if(mEnrolleesData.VictimProfileCurrent.ProximityCaution > 0)
                $('#uDeviceAssignmentsWizardRadiusCautionEdit').val(mEnrolleesData.VictimProfileCurrent.ProximityCaution);

            if (mEnrolleesData.VictimProfileCurrent.ProximityWarning > 0)
                $('#uDeviceAssignmentsWizardRadiusWarningEdit').val(mEnrolleesData.VictimProfileCurrent.ProximityWarning);

            if (mEnrolleesData.VictimProfileCurrent.ProximityDanger > 0)
                $('#uDeviceAssignmentsWizardRadiusDangerEdit').val(mEnrolleesData.VictimProfileCurrent.ProximityDanger);

            lSelectField.append(new Option('No Offender', -1, lSelected));
            for (var lKey in mEnrolleesData.VictimAssignableOffenders) {
                if (mEnrolleesData.VictimAssignableOffenders.hasOwnProperty(lKey)) {
                    var lEnrollee = mEnrolleesData.VictimAssignableOffenders[lKey];
                    var lFullName = lEnrollee.FullName;

                    if (lEnrollee.IsAssigned) {
                        lFullName = lFullName + ' - ' + lEnrollee.PrimaryId + ' (' + localizeText('cEnrolleeAssigned') + ')';
                    }
                    else {
                        lFullName = lFullName + ' - ' + lEnrollee.PrimaryId + ' (' + localizeText('cEnrolleeUnassigned') + ')';
                    }
                    if (mEnrolleesData.VictimProfileCurrent.OffenderId == lEnrollee.Id) {
                        lSelectField.append(new Option(lFullName, lEnrollee.Id, true, true));
                    }
                    else {
                        lSelectField.append(new Option(lFullName, lEnrollee.Id));
                    }
                }
            }
            updateMeasurementUnit(".cRadiusMeasurement");
            break;
    }
    veritracks.localization.localize('#' + aSender.Id);
}
    
function VictimUnassignedTrackingDevices(aIdentifier, aSearchString) {
    "use strict";
    var lBuilder = new SumoPredicateBuilder(),
        lMyAssignments = gCurrentDeviceAssignment[mEnrolleesData.VictimEnrollment.Id],
        lTrackingProductIds = getTrackingProductIds(),
        lDevices = getDataItems('Devices'),
        lProducts = getDataItems('Products'),
        lEnrollee = getDataItem(mEnrolleesData.VictimEnrollment.Id, 'Enrollees'),
        lSort = new SortExpression(),
        lLastContact,        
        lDevice,
        lResult = [],
        lItem,
        lKey;



    lBuilder.AddNewExpressionConditional('Status', getAssignableStatusIds(), false, mRelationalOperatorEnum.In(), mLogicalOperatorEnum.And());
    lBuilder.AddNewExpressionConditional('OrganizationId', lEnrollee.OrganizationId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    lBuilder.AddNewExpressionConditional('ProductId', 108, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    if (!isNullOrUndefined(aIdentifier) && !isNullOrUndefined(aSearchString)) {
        lBuilder.AddNewExpressionConditional(aIdentifier, aSearchString, false, mRelationalOperatorEnum.Like(), mLogicalOperatorEnum.And());
    }
    lDevices = query(getDataItems('Devices'), lBuilder.RootExpression);

    for (lKey in lMyAssignments) {
        if (lMyAssignments.hasOwnProperty(lKey)) {
            lItem = lMyAssignments[lKey];
            lDevice = getDataItem(lItem.Id, 'Devices');
            if (!isNullOrUndefined(lDevice) && [108].indexOf(lDevice.ProductId) !== -1) {
                lDevices[lDevice.Id] = lDevice;
            }
        }
    }

    for (lKey in lDevices) {
        if (lDevices.hasOwnProperty(lKey)) {
            lDevice = $.extend({}, lDevices[lKey]);
            lDevice.ProductName = lProducts[lDevice.ProductId].Name;
            lLastContact = gDeviceLastContact[lDevice.Id];
            if (!isNullOrUndefined(lLastContact)) {
                lDevice.TrackingDeviceContactDateDisplay = DisplayShortDateTime(lLastContact.ContactDate);
                lDevice.LastContactBatteryLevel = DisplayVolts(lLastContact.BatteryVoltage);
                lDevice.LastContactBatteryImage = inventoryBatteryLevelFormatter(lLastContact.BatteryLevel);
                lDevice.PercentGps = DisplayPercent(lLastContact.PercentGps);
                lDevice.ContactStatus = contactStatusImageFormatter(lLastContact.Status);
                lDevice.LastContactDisplay = 'block';
            } else {
                lDevice.ContactStatus = '';
                lDevice.LastContactDisplay = 'none';
            }
            if (lDevice.HasDevicePairingSupport) {
                lDevice.BluTwoCapableUnit = 'block';
            } else {
                lDevice.BluTwoCapableUnit = 'none';
            }
            if (lDevice[aIdentifier].indexOf(aSearchString) !== -1) {
                lResult[lDevice.Id] = lDevice;
            }
        }
    }
    lSort.addAscendingColumn('SerialNumber');
    lResult = lSort.sort(lResult);
    return lResult;
}

function uVictimsDeviceAssignmentsWizardTab_OnClick(aDeviceType) {
    "use strict";
    function onComplete() {
        $(window).resize();
    }

    $('.AssignmentPopupTab.Selected').removeClass('Selected');
    $('.AssignmentPopupTab.' + aDeviceType).addClass('Selected');
    switch (aDeviceType) {
        case 'Map':
            $('#uDeviceAssignmentsWizardMapHolder').show();
            $('#uDeviceAssignmentsWizardContactHolder').hide(onComplete);
            $(window).resize();
            break;
        case 'Contact':
            $('#uDeviceAssignmentsWizardMapHolder').hide();
            $('#uDeviceAssignmentsWizardContactHolder').show(onComplete);
            break;
    }
}

function uVictimsDeviceAssignmentsWizardTrackingDeviceCardView_OnSelectChange(aSender, aSelectedIndex, aParams) {
    "use strict";
    var lSelectedDevice = mEnrolleesControls.TrackingDeviceCardView.selectedDataItem(),
        lBLUPlusUnPairedAssignment = veritracks.system.clientSetting('BluPlusUnpairedEnable'),
        lBuilder = new SumoPredicateBuilder(),
        lSort = new SortExpression(),
        lPointList = [],
        lLabelList = [],
        lContact;

    function onRead(aParams, aData) {
        "use strict";
        FixDates(aData);
        $('#uDeviceAssignmentsWizardListViewHolder').show();
        $('#uDeviceAssignmentsWizardListViewWaiting').hide();
        mEnrolleesControls.DeviceAssignmentsContactList.setDataSource(aData);
    }

    if (!isNullOrUndefined(aSelectedIndex)) {
        $('#uDeviceAssignmentsWizardListViewHolder').hide();
        $('#uDeviceAssignmentsWizardListViewWaiting').show();
        lBuilder.AddNewExpressionConditional('DeviceId', lSelectedDevice.Id, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        lSort.addDescendingColumn('TrackDate');
        mEnrolleesControls.DeviceAssignmentsContactList.setDataSource([]);
        GetDeviceContact(lSelectedDevice.Id, new Date(0).toWcf(), onRead, null);
        //ReadMultiple(gObjectList.DeviceContact.AssemblyQualifiedName, lBuilder.RootExpression, 0, onRead, null, null, lSort, 20);
    } else {
        onRead(null, []);
    }

    if (!isNullOrUndefined(lSelectedDevice) && lSelectedDevice.ProductId === 108) {
        $('#uDeviceAssignmentsWizardMapTab').show();
        lContact = gDeviceLastContact[lSelectedDevice.Id];
        if (!isNullOrUndefined(lContact) && (lContact.Latitude !== 0 || lContact.Longitude !== 0)) {
            //lPointList.push({
            //    'data': lContact,
            //    'latitude': lContact.Latitude,
            //    'longitude': lContact.Longitude,
            //    'anchor': { 'x': 6, 'y': 6 },
            //    'iconUri': 'Images/Maps/Trackpoints/1100000.png',
            //    'hoverText': DisplayShortDateTime(lContact.TrackDate)
            //});
            lPointList.push(veritracks.mapping.prepareTrackpointMarkerItem({ 'TrackTypeId': 8, 'Latitude': lContact.Latitude, 'Longitude': lContact.Longitude, 'TrackDate': lContact.TrackDate }, 1));
            lLabelList.push({
                'data': lContact,
                'latitude': lContact.Latitude,
                'longitude': lContact.Longitude,
                'text': lSelectedDevice.SerialNumber,
                'horizontalOffset': -15,
                'verticalOffset': -15,
                'cssClass': 'NumericLabel'
            });
        }
    } else {
        $('#uDeviceAssignmentsWizardMapTab').hide();
        uVictimsDeviceAssignmentsWizardTab_OnClick('Contact');
    }
    mEnrolleesControls.DeviceAssignmentsMap.layerSetDataSource('Contact', lPointList);
    mEnrolleesControls.DeviceAssignmentsMap.layerSetDataSource('Labels', lLabelList);
    mEnrolleesControls.DeviceAssignmentsMap.fitBounds();

    if (isNullOrUndefined(lSelectedDevice)) {
        $('.sumo-wizard-blade-command .sumo-wizard-save').hide();
        $('.sumo-wizard-blade-command .sumo-wizard-next').hide();
    } else {
        $('.sumo-wizard-blade-command .sumo-wizard-save').show();
        $('.sumo-wizard-blade-command .sumo-wizard-next').show();
    }
}

function uVictimsDeviceAssignmentsWizard_OnSave(aSender, aStepId, aParams) {
    var lBuilder = new SumoPredicateBuilder(),
        lEnrollment = mEnrolleesData.VictimEnrollment,
        lEnrollee = getDataItem(lEnrollment.Id, 'Enrollees'),
        lAssignments = gCurrentDeviceAssignment[lEnrollment.Id],
        lDevice,
        lVictimDevice = getDataItem(lEnrollment.TrackingDeviceId, 'Devices'),
        lOffenderId = parseInt($('#uDeviceAssignmentWizardOffenderSelectEdit').val()),
        lOffenderDeviceAssignments,
        lOffenderDevice,
        lDevices = [],
        lRadiusIsValid = true,
        lItem,
        lKey;

    if (lOffenderId > 0) {
        lOffenderDeviceAssignments = gCurrentDeviceAssignment[lOffenderId];
        for (var lKeyA in lOffenderDeviceAssignments) {
            if (lOffenderDeviceAssignments.hasOwnProperty(lKeyA)) {
                if (lOffenderDeviceAssignments[lKeyA].ProductId == 103 || lOffenderDeviceAssignments[lKeyA].ProductId == 151) {
                    lOffenderDevice = getDataItem(lOffenderDeviceAssignments[lKeyA].Id, 'Devices');
                }
            }
        }
    }

    //if (isNullOrUndefined(mEnrolleesData.Validator) || mEnrolleesData.Validator.IsValid()) {

        lEnrollee = $.extend({}, lEnrollee);
        lEnrollee.IsAssigned = true;

        if (!isNullOrUndefined(lAssignments)) {
            for (lKey in lAssignments) {
                if (lAssignments.hasOwnProperty(lKey)) {
                    lItem = lAssignments[lKey];
                    lDevice = getDataItem(lItem.Id, 'Devices');
                    lDevice = $.extend({}, lDevice);
                    lDevice.Status = 5;
                    lDevices.push(lDevice);
                }
            }
        }

        lDevice = getDataItem(lEnrollment.TrackingDeviceId, 'Devices');
        if (lDevice.Status === 5) {
            lDevice = $.extend({}, lDevice);
            lDevice.Status = 4;
            lDevices.push(lDevice);
        }
        lDevice = null;

    // write process



        if (aStepId == 2) {
            mEnrolleesData.VictimProfileCurrent.ProximityCaution = parseInt($('#uDeviceAssignmentsWizardRadiusCautionEdit').val());
            mEnrolleesData.VictimProfileCurrent.ProximityWarning = parseInt($('#uDeviceAssignmentsWizardRadiusWarningEdit').val());
            mEnrolleesData.VictimProfileCurrent.ProximityDanger = parseInt($('#uDeviceAssignmentsWizardRadiusDangerEdit').val());
            if (mEnrolleesData.VictimProfileCurrent.ProximityCaution <= mEnrolleesData.VictimProfileCurrent.ProximityWarning || mEnrolleesData.VictimProfileCurrent.ProximityCaution <= mEnrolleesData.VictimProfileCurrent.ProximityDanger) {
                $('#proximityError').show();
                lRadiusIsValid = false;
            }
            if (mEnrolleesData.VictimProfileCurrent.ProximityWarning <= mEnrolleesData.VictimProfileCurrent.ProximityDanger || mEnrolleesData.VictimProfileCurrent.ProximityWarning >= mEnrolleesData.VictimProfileCurrent.ProximityCaution) {
                $('#proximityError').show
                lRadiusIsValid = false;
            }
            if (mEnrolleesData.VictimProfileCurrent.ProximityDanger >= mEnrolleesData.VictimProfileCurrent.ProximityWarning || mEnrolleesData.VictimProfileCurrent.ProximityDanger >= mEnrolleesData.VictimProfileCurrent.ProximityCaution) {
                $('#proximityError').show();
                lRadiusIsValid = false;
            }
        }


        if (mEnrolleesData.Validator.IsValid() && lRadiusIsValid) {
            setLoadingBarStatus('uEnrolleesDeviceAssignmentsWizardLoadingBar', 'uDeviceAssignmentsWizardContentHolder', true);
            if (!isNullOrUndefined(mEnrolleesData.Validator)) {
                mEnrolleesData.Validator.dispose();
                mEnrolleesData.Validator = null;
            }

            $('.sumo-wizard-close').hide();
            $('.sumo-wizard-save').hide();
            

            if (lOffenderId != mEnrolleesData.VictimProfileCurrent.OffenderId && lOffenderId && mEnrolleesData.VictimProfileCurrent.OffenderId > 0) {
                victimUpdateOffenderFlag(mEnrolleesData.VictimProfileCurrent.OffenderId, false);
            }
            mEnrolleesData.VictimProfileCurrent.OffenderId = lOffenderId;
            victimProfileInitial_OnSave();
        }


        function victimProfileInitial_OnSave(aParams, aData) {
            WriteVictimDeviceAssignmentPR(mEnrolleesData.VictimProfileCurrent, lVictimDevice, lOffenderDevice, victimAssignment_OnSuccess, victimAssignment_OnFailure,
            {
                'Enrollment': lEnrollment,
                'Devices': lDevices,
                'Enrollee': lEnrollee
            });
        }
}


function victimAssignment_OnSuccess(aParams, aData) {
    if (aData) {
        mEnrolleesData.VictimProfileCurrent.ProximityCautionExtId = aData.ProximityCautionExtId;
        mEnrolleesData.VictimProfileCurrent.ProximityWarningExtId = aData.ProximityWarningExtId;
        mEnrolleesData.VictimProfileCurrent.ProximityDangerExtId = aData.ProximityDangerExtId;
        mEnrolleesData.VictimProfileCurrent.GothimInquiryExtId = aData.GothimInquiryExtId;
        mEnrolleesData.VictimProfileCurrent.FirstName = aParams.Enrollee.FirstName;
        mEnrolleesData.VictimProfileCurrent.LastName = aParams.Enrollee.LastName;
        if (mEnrolleesData.VictimProfileCurrent) {
            //   WriteSingle(mEnrolleesData.VictimProfileCurrent, enrolleesVictimEnrolleeSave_OnComplete, enrolleesVictimEnrolleeSave_OnFailure, lEnrolleeEdit, true);
            WriteSingle(mEnrolleesData.VictimProfileCurrent, victimUpdateEnrollment, failure, aParams, true);
            if (mEnrolleesData.VictimProfileCurrent.OffenderId > 0) {
                victimUpdateOffenderFlag(mEnrolleesData.VictimProfileCurrent.OffenderId, true);
            }
        }
    }
}

function victimUpdateOffenderFlag(aOffenderId, aHasVictim) {
    var lOffender = getDataItem(aOffenderId, 'Enrollees');
    lOffender.HasVictimFlag = aHasVictim;

    WriteSingle(lOffender, null, null, null, false);
}

function victimUpdateEnrollment(aParams, aData) {
    WriteSingle(aParams.Enrollment, victimEnrollment_OnSuccess, failure, aParams, true);
}

function victimAssignment_OnFailure() {
    mActivityNotification.addNotification(localizeWrapper('cDefaultGothimSaveFail'));
}
function victimEnrollment_OnSuccess(aParams, aData) {
    if (aParams.Devices.length > 0) {
        WriteMultiple(aParams.Devices, victimDevices_OnSuccess, failure, aParams, false);
    } else {
        victimDevices_OnSuccess(aParams, []);
    }
}

function victimDevices_OnSuccess(aParams, aData) {
    var lItem,
    lKey;

    FixDates(aData);
    for (lKey in aData) {
        if (aData.hasOwnProperty(lKey)) {
            lItem = aData[lKey];
            setDataItem(lItem.Id, 'Devices', lItem);
        }
    }

    aParams.Enrollee.Birthdate = BirthDateStringFormatter(aParams.Enrollee.Birthdate);
    WriteSingle(aParams.Enrollee, victimEnrollee_OnSuccess, failure, aParams, false);
}

function victimEnrollee_OnSuccess(aParams, aData) {
    "use strict";
    var lBuilder = new SumoPredicateBuilder(),
            lAssignments = gCurrentDeviceAssignment[mEnrolleesData.VictimProfileCurrent.Id],
            lAssignment,
            lAssignmentWrite = [],
            lKey,
            lNow = new Date();

    FixDates(aData);
    aData.InMyOrganization = (gUserDetails.OrganizationIds.indexOf(aData.OrganizationId) !== -1);
    setDataItem(aData.Id, 'Enrollees', aData);

    lBuilder.AddNewExpressionConditional('EndDate', lNow, false, mRelationalOperatorEnum.GreaterThan(), mLogicalOperatorEnum.And());
    lAssignments = query(lAssignments, lBuilder.RootExpression);
    lBuilder.Clear();

    for (lKey in lAssignments) {
        if (lAssignments.hasOwnProperty(lKey)) {
            lAssignment = lAssignments[lKey];
            lAssignment.ReasonForChange = 1;
            lAssignment.EndDate = lNow;
            lAssignmentWrite.push(prepareObjectForWcf(lAssignment));
        }
    }

    WriteMultiple(lAssignmentWrite, victimDeviceUnAssignment_OnSuccess, failure, aParams, false);
}

function victimDeviceUnAssignment_OnSuccess(aParams, aData) {
    "use strict";
    var lAssignment,
        lKey;
    function onSuccess() {
        mCache.unbind('CurrentDeviceAssignmentsupdated', onSuccess, aParams);
        enrolleesDataListConverter();
        window.location.hash = 'Enrollees.Victims.Profile.Assignments.' + aParams.Enrollee.Id;
        uVictimsDeviceAssignmentsWizard_OnClose();
    }

    FixDates(aData);

    for (lKey = 0; lKey < aData.length; lKey++) {
        lAssignment = aData[lKey];
        setDataItem(lAssignment.Id, 'CurrentDeviceAssignments', lAssignment);
    }

    mCache.bind('CurrentDeviceAssignmentsupdated', onSuccess, aParams);
    mCache.UpdateItem('CurrentDeviceAssignments');

}

function uVictimsDeviceAssignmentsWizard_OnClose() {
    setLoadingBarStatus('uEnrolleesDeviceAssignmentsWizardLoadingBar', 'uDeviceAssignmentsWizardContentHolder', false);
    $('#uWizardHolder').hide();
    mEnrolleesControls.DeviceAssignmentsWizard.unbind('changing', uVictimsDeviceAssignmentsWizard_OnChanging);
    mEnrolleesControls.DeviceAssignmentsWizard.unbind('changed', uVictimsDeviceAssignmentsWizard_OnChanged);
    mEnrolleesControls.DeviceAssignmentsWizard.unbind('save', uVictimsDeviceAssignmentsWizard_OnSave);
    mEnrolleesControls.DeviceAssignmentsWizard.unbind('close', uVictimsDeviceAssignmentsWizard_OnClose);
    if (!isNullOrUndefined(mEnrolleesControls.DeviceAssignmentsMap)) {
        mEnrolleesControls.DeviceAssignmentsMap.dispose();
        mEnrolleesControls.DeviceAssignmentsMap = null;
    }
    if (!isNullOrUndefined(mEnrolleesControls.DeviceAssignmentsWizard)) {
        mEnrolleesControls.DeviceAssignmentsWizard.dispose();
        mEnrolleesControls.DeviceAssignmentsWizard = null;
    }
    if (!isNullOrUndefined(mEnrolleesControls.TrackingDeviceCardView)) {
        mEnrolleesControls.TrackingDeviceCardView.dispose();
        mEnrolleesControls.TrackingDeviceCardView = null;
    }
    if (!isNullOrUndefined(mEnrolleesControls.DeviceAssignmentsContactList)) {
        mEnrolleesControls.DeviceAssignmentsContactList.dispose();
        mEnrolleesControls.DeviceAssignmentsContactList = null;
    }
    if (!isNullOrUndefined(mEnrolleesData.Validator)) {
        mEnrolleesData.Validator.dispose();
        mEnrolleesData.Validator = null;
    }
}

function uVictimsDeviceAssignmentsWizardTrackingDeviceCardView_OnRender(aSender) {
    var lSelectedIndex = mEnrolleesData.VictimEnrollment.TrackingDeviceId,
        lBuilder = new SumoPredicateBuilder(),
        lProductIds,
        lDeviceAssignments = gCurrentDeviceAssignment[mEnrolleesData.VictimEnrollment.Id],
        lDevice,
        lItem,
        lKey;

    if (lSelectedIndex === -1) {
        lProductIds = [108]; // stalker alert

        for (lKey in lDeviceAssignments) {
            if (lSelectedIndex === -1 && lDeviceAssignments.hasOwnProperty(lKey)) {
                lItem = lDeviceAssignments[lKey];
                lDevice = getDataItem(lItem.Id, 'Devices');
                if (lProductIds.indexOf(lDevice.ProductId) !== -1) {
                    lSelectedIndex = lDevice.Id;
                }
            }
        }
    }
    if (lSelectedIndex !== -1) {
        aSender.selected(lSelectedIndex);
    }
}

function uVictimDeviceAssignmentsWizardTrackingSearch_OnChange() {
    "use strict";
    if (!isNullOrUndefined(mEnrolleesControls.TrackingDeviceCardView)) {
        var lValue = $('#uDeviceAssignmentsWizardTrackingSearch').val(),
            lList = VictimUnassignedTrackingDevices('SerialNumber', lValue);
        mEnrolleesControls.TrackingDeviceCardView.setDataSource(lList);
        if (lList.length === 0) {
            $('.sumo-wizard-blade-command .sumo-wizard-save').hide();
            $('.sumo-wizard-blade-command .sumo-wizard-next').hide();
        } else {
            $('.sumo-wizard-blade-command .sumo-wizard-save').show();
            $('.sumo-wizard-blade-command .sumo-wizard-next').show();
        }
    }
}


// unassignment 
function uEnrolleesRemoveVictimAssignment_OnClick() {
    "use strict";
    var lOffender = getDataItem(mEnrolleesData.VictimProfileCurrent.OffenderId, 'Enrollees'),
    lOffenderDeviceAssignment = null,
    lVictimDeviceAssignmnet = gCurrentDeviceAssignment[mEnrolleesData.VictimProfileCurrent.Id],
    lOffenderDevice = null,
    lVictimDevice = null;

    if (!isNullOrUndefined(lOffender)) {
        lOffenderDeviceAssignment = gCurrentDeviceAssignment[lOffender.Id];
        if (!isNullOrUndefined(lOffenderDeviceAssignment)) {
            var lCurrentAssignment = null;
            for (var lKey in lOffenderDeviceAssignment) {
                if (lOffenderDeviceAssignment.hasOwnProperty(lKey)) {
                    lCurrentAssignment = lOffenderDeviceAssignment[lKey];
                }
            }
            lOffenderDevice = getDataItem(lCurrentAssignment.Id, 'Devices');
        }
    }

    if (!isNullOrUndefined(lVictimDeviceAssignmnet)) {
        var lCurrentAssignment = null;
        for (var lKey in lVictimDeviceAssignmnet) {
            if (lVictimDeviceAssignmnet.hasOwnProperty(lKey)) {
                lCurrentAssignment = lVictimDeviceAssignmnet[lKey];
            }
        }
        lVictimDevice = getDataItem(lCurrentAssignment.Id, 'Devices');            
    }
    
    WriteVictimDeviceUnAssignmentPR(mEnrolleesData.VictimProfileCurrent, lVictimDevice, lOffenderDevice, victimDeviceUnassignment_OnSuccess, victimDeviceUnassignment_OnFailure);
}

function victimDeviceUnassignment_OnSuccess(aParams, aData) {
    if (aData) {
        if (mEnrolleesData.VictimProfileCurrent.OffenderId > -1) {
            removeOffenderVictimPair(mEnrolleesData.VictimProfileCurrent.OffenderId);
        }
        mEnrolleesData.VictimProfileCurrent.GothimInquiryExtId = -1;
        mEnrolleesData.VictimProfileCurrent.OffenderId = -1;
        mEnrolleesData.VictimProfileCurrent.ProximityCautionExtId = -1;
        mEnrolleesData.VictimProfileCurrent.ProximityDangerExtId = -1;
        mEnrolleesData.VictimProfileCurrent.ProximityWarningExtId = -1;
        mEnrolleesData.VictimProfileCurrent.type = 'VictimProfile:www.veritracks.com';
        WriteSingle(mEnrolleesData.VictimProfileCurrent, victimProfileUnEnrollment_OnSuccess, failure, aParams, true);
    }
}

function removeOffenderVictimPair(aId) {
    var lEnrollee = getDataItem(aId, 'Enrollees');

    if (lEnrollee) {
        lEnrollee.HasVictimFlag = false;
        WriteSingle(lEnrollee, removeOffenderVictimPair_OnSuccess, failure, null, true);
    }
}

function removeOffenderVictimPair_OnSuccess(aParams, aData) {
    if (aData) {
        setDataItem(aData.Id, 'Enrollees', aData);
    }
}

function victimDeviceUnassignment_OnFailure(a,b,c) {
    console.log(a);
    console.log(b);
    console.log(c);
}

function victimProfileUnEnrollment_OnSuccess(aParams, aData) {
    var lVictimUnenrollment = new VictimUnenrollment();
    lVictimUnenrollment.Id = mEnrolleesData.VictimProfileCurrent.Id;
    lVictimUnenrollment.VictimUserId = mEnrolleesData.VictimProfileCurrent.VictimUserId;
    lVictimUnenrollment.VictimSearchType = 1;
    WriteSingle(lVictimUnenrollment, enrolleeVictimUnenrollmentWrite_OnSuccess, failure, mEnrolleesData.VictimCurrentId, true);
}

function enrolleeVictimUnenrollmentWrite_OnSuccess(aParams, aData) {
    var lAssignments = gCurrentDeviceAssignment[mEnrolleesData.VictimCurrentId];
    var lAssignment;
    var lDevice;
    var lEnrollee = $.extend({}, getDataItem(mEnrolleesData.VictimCurrentId, 'Enrollees'));
    var lNow = new Date();

    for (var lKey in lAssignments) {
        if (lAssignments.hasOwnProperty(lKey)) {
            lAssignment = lAssignments[lKey];
            lDevice = getDataItem(lAssignment.Id, 'Devices');
            lAssignment.EndDate = lNow;
            lDevice.Status = 5;
        }
    }
    lEnrollee.IsAssigned = false;

    if (lAssignment && lDevice) {
        WriteMultiple([prepareObjectForWcf(lAssignment)], victimDeviceAssignment_OnSuccess, failure, aData.Id, false);
        WriteMultiple([lDevice], enrolleeDeviceSetStatus_OnSuccess, failure, aData.Id, true);
        WriteSingle(lEnrollee, enrolleeDeviceAssignmentEnrollee_OnSuccess, failure, aData.Id, true);
    }
}

function victimDeviceAssignment_OnSuccess(aParams, aData) {
    var lAssignment,
        lNow = new Date(),
        lKey;

    function onSuccess() {
        mCache.unbind('CurrentDeviceAssignmentsupdated', onSuccess, aParams);
        enrolleesDataListConverter();
        window.location.hash = 'Enrollees.Victims.Profile.Assignments.' + mEnrolleesData.VictimCurrentId;
        //enrolleesResetOffenderCardView(aParams);
        //mStateManagerEnrolleesSecondaryAssignments_Init();
    }

    FixDates(aData);
    mCache.bind('CurrentDeviceAssignmentsupdated', onSuccess, aParams);
    mCache.UpdateItem('CurrentDeviceAssignments');

    //gCurrentDeviceAssignment[aParams] = [];
    for (lKey = 0; lKey < aData.length; lKey++) {
        lAssignment = aData[lKey];
        setDataItem(lAssignment.Id, 'CurrentDeviceAssignments', lAssignment);
    }
}


// MAP Info
function VictimMapPopulate_GetDateRange() {
    "use strict";
    var lMinutes = 1440,
        uEnrolleeMapTimeFilter = $('#uEnrolleeMapTimeFilter'),
        lTripStartDate = new Date(mEnrolleesData.MapEndDate),
        lTripEndDate = new Date(mEnrolleesData.MapEndDate),
        lStartDateFilterEditable = veritracks.system.clientSetting('StartDateFilterEditable'),
        lTripTimeValue,
        lValue;

    if (uEnrolleeMapTimeFilter.length > 0) {
        //lHours = parseInt(uEnrolleeMapTimeFilter.val());
        lMinutes = parseInt(uEnrolleeMapTimeFilter.val());
    }
    lTripStartDate.addMinutes(-1 * lMinutes);

    return { 'startDate': lTripStartDate, 'endDate': lTripEndDate };
}

function victimMapPopulateNextDay_GetDateRange() {
    "use strict";
    var lMinutes = 1440,
        uEnrolleeMapTimeFilter = $('#uEnrolleeMapTimeFilter'),
        lTripStartDate,
        lTripEndDate = new Date(mEnrolleesData.MapEndDate),
        lIsValid = true;

    if (uEnrolleeMapTimeFilter.length > 0) {
        lMinutes = parseInt(uEnrolleeMapTimeFilter.val());
    }

    lTripEndDate.addMinutes(-1 * lMinutes);
    lTripStartDate = new Date(lTripEndDate);
    lTripStartDate.addMinutes(-1 * lMinutes);

    if (lMinutes > 1440)
        lIsValid = false;

    return { 'startDate': lTripStartDate, 'endDate': lTripEndDate, 'IsValid': lIsValid };

}

function victim_toggleuLastContactButton() {
    "use strict";
    var lDateRange = VictimMapPopulate_GetDateRange(),
        lEnrollee = mEnrolleesControls.CardView.selectedDataItem(),
        lEnrolleeData = lEnrollee.Enrollee;

    if (mStateManager.Settings()[1] === 'Map' && (displayEventInEnrolleeTimeZone(lEnrollee.LastContactDate, lEnrolleeData) <= lDateRange.startDate || displayEventInEnrolleeTimeZone(lEnrollee.LastContactDate, lEnrolleeData) >= lDateRange.endDate)) {
        // $('#uLastContactButton').show(); removed, preferred Now button.
        $('#uMapNowButton').show();// Removed for Now button being obsolete same as same commented line below update (EE) added for iteration 2 purposes
    } else {
        //$('#uLastContactButton').hide();
        $('#uMapNowButton').hide();
    }
}

    function uShowVictimTrackpointsButton_OnClick() {
        enrolleesVictimMapTypeChange('5');
    }

    function uShowVictimTrackPointEventsButton_OnClick() {
        "use strict";
        enrolleesVictimMapTypeChange('20');
    }


    function enrolleesVictimMapTypeChange(aIndex) {
        "use strict";
        var lValue = mEnrolleesControls.VictimTrackpointDetailCardViewFilter.columnValue('TypeVictim'),
            lIndex = lValue.indexOf(aIndex),
            lItem,
            mMap = mEnrolleesControls.EnrolleesMap.getMap(),
            lCenter = mMap.getCenter(),
            lKey;
        veritracks.enrollees.mapping.PreviousZoom(mEnrolleesControls.EnrolleesMap.getZoom());
        if (lValue.length === 0) {
            for (lKey in gMapFilterList) {
                if (gMapFilterList.hasOwnProperty(lKey)) {
                    lItem = gMapFilterList[lKey];
                    if (lItem.Id != aIndex) {
                        lValue.push(lItem.Id.toString());
                    }
                }
            }
        } else {
            if (lIndex === -1) {
                lValue.push(aIndex);
            } else {
                lValue.remove(lIndex, lIndex);
            }
        }
        mEnrolleesControls.VictimTrackpointDetailCardViewFilter.columnValue('TypeVictim', lValue);
        mEnrolleesControls.VictimTrackpointDetailCardViewFilter.filter();

        // if (lIndex !== -1) {
        mMap.setZoom(veritracks.enrollees.mapping.data.PreviousZoom);
        mEnrolleesControls.EnrolleesMap.setCenter(lCenter.lat(), lCenter.lng());
        //}
    }

// add secondary offender info

    function uAddVictimsecondaryButton_OnClick() {
        "use strict";
        var lVictim;
        
        if ($('#uAddVictimsecondaryButton').hasClass('Selected')) {
            $('#uAddVictimsecondaryButton').removeClass('Selected');
            $('#uAddVictimsecondaryButton').attr('title', 'add offender from victim map');
            removeOffenderSecondaryMap_OnClick();
        } else {
            if (mEnrolleesData.VictimProfileCurrent && mEnrolleesData.VictimCurrentId == mEnrolleesData.VictimProfileCurrent.Id) {
                lVictim = mEnrolleesData.VictimProfileCurrent;
            }
            if (lVictim) {
                addSecondaryOffender_Map(lVictim);
            } else {
                var lBuilder = new SumoPredicateBuilder();
                lBuilder.AddNewExpressionConditional('Id', mEnrolleesData.VictimCurrentId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
                ReadMultiple(gObjectList.VictimProfile.AssemblyQualifiedName, lBuilder.RootExpression, 0, addSecondaryOffender_OnSuccess, failure, null, null, 0);
            }
        }

        function addSecondaryOffender_OnSuccess(aParams, aData) {
            if (aData.length > 0) {
                mEnrolleesData.VictimProfileCurrent = aData[0];
                addSecondaryOffender_Map(mEnrolleesData.VictimProfileCurrent);
            }
        }

        function addSecondaryOffender_Map(aVictim) {
            if (aVictim.OffenderId > 0 || aVictim.SamaAssociateEnrolleeId > 0) {
                var EnrolleeId = aVictim[aVictim.SamaAssociateEnrolleeId > 0?'SamaAssociateEnrolleeId':'OffenderId'];
                $('#uAddVictimsecondaryButton').addClass('Selected');
                $('#uAddVictimsecondaryButton').attr('title', 'remove offender from victim map');
                mEnrolleesData.VictimSecondaryCurrentId = EnrolleeId;
                var lEnrollee = getDataItem(EnrolleeId, 'Enrollees');
                mActivityNotification.addNotification(localizeWrapper('cEnrolleeAddOffenderToVictimMap') + lEnrollee.FullName);
                offenderSecondaryVictimMapPopulate(true);
            } else {
                var lEnrollee = getDataItem(aVictim.Id, 'Enrollees');
                mActivityNotification.addNotification(lEnrollee.FullName + " does not have an offender associated with them.");
            }
        }
    }

function removeOffenderSecondaryMap_OnClick() {
    veritracks.enrollees.mapping.clear(2);
    ClosePopup();
    mEnrolleesData.VictimSecondaryCurrentId = null;
    $('#uMapPlaybackPanel').show();
}

function offenderSecondaryVictimMapPopulate(){
    "use strict";
        var lDateRange = offenderMapPopulate_GetDateRange(),
    lTripStartDate = lDateRange.startDate,
    lTripEndDate = lDateRange.endDate,
    lSecondaryOffender = getDataItem(mEnrolleesData.VictimSecondaryCurrentId, 'Enrollees');

    if (!lSecondaryOffender.InMyOrganization)
        $('#uEnrolleesPrintButton').hide();
    else
        $('#uEnrolleesPrintButton').show();

    if (!isNullOrUndefined(mEnrolleesData.VictimSecondaryCurrentId) && mEnrolleesData.VictimSecondaryCurrentId > 0) {
        if (!$('#uAddVictimsecondaryButton').hasClass('Selected')) {
            $('#uAddVictimsecondaryButton').addClass('Selected');
        }
    }
    function onReplace(aId) {
        mEnrolleesData.OffenderMapRequestCount -= 3;
        alert(mEnrolleesData.OffenderMapRequestCount);
    }
    var ltTripStartDate = FixSentDate(lTripStartDate, lSecondaryOffender);
    var ltTripEndDate = FixSentDate(lTripEndDate, lSecondaryOffender);
    if (!isNullOrUndefined(mEnrolleesData.VictimSecondaryCurrentId) && mEnrolleesData.VictimSecondaryCurrentId != mEnrolleesData.VictimCurrentId) {
        veritracks.enrollees.mapping.initialize(mEnrolleesData.VictimSecondaryCurrentId, 2, ltTripStartDate, ltTripEndDate);
        var lNextDay = offenderMapPopulateNextDay_GetDateRange(ltTripEndDate);
        if (lNextDay.IsValid)
            veritracks.enrollees.mapping.initializeNextDay(mEnrolleesData.VictimSecondaryCurrentId, 2, lNextDay.startDate, lNextDay.endDate);
    }
}

// notifications processing

function uVictimNotificationsListView_OnSelectChange() {
    "use strict";
    var lSelected = mEnrolleesControls.VictimNotificationsListView.selected();

    if (!isNullOrUndefined(lSelected) && lSelected.length > 0) {
        $('#uRemoveVictimNotificationButton').show();
        if (lSelected.length === 1) {
            $('#uEditVictimNotificationButton').show();
        } else {
            $('#uEditVictimNotificationButton').hide();
        }
    } else {
        $('#uEditVictimNotificationButton').hide();
        $('#uRemoveVictimNotificationButton').hide();
    }
}


function uEnrolleesVictimsListView_Init() {
    "use strict";
    // need this since this object is loaded whenever you select a new card can be null.
    if (mEnrolleesData.VictimProfileCurrent) {
        // if (isNullOrUndefined(mEnrolleesControls.VictimNotificationsListView)) {
            mEnrolleesControls.VictimNotificationsListView = new sumo.controls.ListView('uVictimNotificationsListView', 'uVictimNotificationsListViewHolder', {
                'keyField': 'Id',
                'keyFieldType': 'number',
                'cssClass': 'VeritracksSelectListView',
                'selectMethod': 'auto',
                'canUnselect': true
            }, [
                { 'id': 'Selection', 'title': '', 'dataField': 'Id', 'width': 'autoData', 'minWidth': 20, 'sortable': false, 'cssClass': null, 'dataType': 'number', 'formatMethod': selectionColumnFormatter, 'canResize': false },
                { 'id': 'NotificationTypeId', 'title': localizeWrapper('cEvent'), 'dataField': 'NotificationTypeId', 'width': 'autoData', 'minWidth': 100, 'sortable': false, 'canResize': true, 'dataType': 'number', 'formatMethod': agentNotificationTypeFormatter },
                { 'id': 'ContactTypeId', 'title': localizeWrapper('cEventMethod'), 'dataField': 'ContactTypeId', 'width': 'autoData', 'minWidth': 100, 'sortable': false, 'canResize': true, 'dataType': 'number', 'formatMethod': agentNotificationContactTypeFormatter },
                { 'id': 'ContactFormatId', 'title': localizeWrapper('cEventFormat'), 'dataField': 'ContactFormatId', 'width': 'autoData', 'minWidth': 100, 'sortable': false, 'canResize': true, 'dataType': 'number', 'formatMethod': agentNotificationContactFormatFormatter }
            ]);
        //   }

        mEnrolleesControls.VictimNotificationsListView.bind('selectedchanged', veritracks.security.controller.extendSession);
        mEnrolleesControls.VictimNotificationsListView.bind('selectedchanged', uVictimNotificationsListView_OnSelectChange);
        //mAgentsControls.ImmediateNotificationsListView.bind('sort', uImmediateNotificationsListView_OnSort);
        enrolleesVictimNotifications_Populate();
        $('#uAddVictimNotificationButton').show();
    } else {
        $('#uAddVictimNotificationButton').hide();
        $('#uEditVictimNotificationButton').hide();
        $('#uRemoveVictimNotificationButton').hide();
    }
}

function enrolleesVictimNotificationsData_Init(aData) {
    "use strict";
    var lBuilder = new SumoPredicateBuilder(),
        lItem,
        lKey;
    FixDates(aData);

    for (lKey in aData) {
        if (aData.hasOwnProperty(lKey)) {
            lItem = aData[lKey];
            mEnrolleesData.VictimNotifications[lItem.Id] = lItem;
        }
    }
    lBuilder.AddNewExpressionConditional('IsActive', true, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    mEnrolleesData.VictimNotifications = query(mEnrolleesData.VictimNotifications, lBuilder.RootExpression);

    mEnrolleesControls.VictimNotificationsListView.setDataSource(mEnrolleesData.VictimNotifications);
}

function enrolleesVictimNotifications_OnComplete(aParams, aData) {
    "use strict";
    ClosePopup();
    enrolleesVictimNotificationsData_Init(aData);
}

function enrolleesVictimNotifications_Populate() {
    "use strict";
    var lVictim = mEnrolleesControls.CardView.selectedDataItem(),
        lBuilder = new SumoPredicateBuilder();

    if (!isNullOrUndefined(lVictim)) {
        mEnrolleesData.VictimNotifications = [];
        mEnrolleesControls.VictimNotificationsListView.setDataSource([]);
        uVictimNotificationsListView_OnSelectChange();
        lBuilder.AddNewExpressionConditional('AgentId', mEnrolleesData.VictimProfileCurrent.VictimUserId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        lBuilder.AddNewExpressionConditional('IsActive', true, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        lBuilder.AddNewExpressionConditional('IsImmediate', true, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        //lBuilder.AddNewExpressionConditional('WorkingHoursType', 2, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        ReadMultiple(gObjectList.Notification.AssemblyQualifiedName, lBuilder.RootExpression, 0, enrolleesVictimNotifications_OnComplete, null, {}, null, 0, true);
    }
}


function uRemoveVictimNotificationButton_OnClick() {
    "use strict";
    var lSelectedItems = mEnrolleesControls.VictimNotificationsListView.selectedDataItem(),
        lNotificationWrite = [],
        lItem,
        lKey;

    for (lKey in lSelectedItems) {
        if (lSelectedItems.hasOwnProperty(lKey)) {
            lItem = lSelectedItems[lKey];
            lItem = $.extend({}, lItem);
            lItem.IsActive = false;
            lNotificationWrite.push(lItem);
        }
    }

    if (lNotificationWrite.length > 0) {
        WriteMultiple(lNotificationWrite, enrolleesVictimNotifications_OnComplete, null, {}, true);
    }
}

function enrolleesVictimAddImmediateNotifications_OnClick() {
    "use strict";
    var lNotification = new Notification(),
        lBuilder = new SumoPredicateBuilder(),
        lContactTypeId = parseInt($('#uVictimNotificationContactTypeIdEdit').val()),
        lNotificationTypeId = parseInt($('#uVictimNotificationNotificationTypeIdEdit').val()),
        lFormatTypeId = parseInt($('#uVictimNotificationContactFormatIdEdit').val()),
        lQuery;

    lBuilder.AddNewExpressionConditional('ContactFormatId', lFormatTypeId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    lBuilder.AddNewExpressionConditional('ContactTypeId', lContactTypeId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    lBuilder.AddNewExpressionConditional('NotificationTypeId', lNotificationTypeId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    lBuilder.AddNewExpressionConditional('IsActive', true, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    lBuilder.AddNewExpressionConditional('AgentId', mEnrolleesData.VictimProfileCurrent.VictimUserId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    lQuery = query(mEnrolleesData.VictimNotifications, lBuilder.RootExpression);
    if (lQuery.length > 0) {
        mActivityNotification.addNotification(localizeWrapper('cAgentNotificationAlreadyExists'));
        ClosePopup();
    } else {
        lNotification.AgentId = mEnrolleesData.VictimProfileCurrent.VictimUserId;
        lNotification.ContactTypeId = lContactTypeId;
        lNotification.UserContactPriority = lContactTypeId;
        lNotification.ContactFormatId = lFormatTypeId;
        lNotification.NotificationTypeId = lNotificationTypeId;
        lNotification.IsImmediate = 1;
        lNotification.WorkingHoursType = 2;
        lNotification.Scope = 1;
        WriteMultiple([lNotification], enrolleesVictimNotifications_OnComplete, null, {}, true);
    }
}
function victimNotificationMethod_OnChange(){
    var lFormats = getDataItems('UserContactFormat');
    var lValue = $("#uVictimNotificationContactTypeIdEdit option:selected").val();
    if(parseInt(lValue) == 3){
        var lBuilder = new SumoPredicateBuilder();
        lBuilder.AddNewExpressionConditional('Id', 1, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        lFormats = query(lFormats, lBuilder.RootExpression);
    }
    populateEditView(null, [
        { 'Id': 'ContactFormatId', 'Type': 'Dropdown', 'DataSource': lFormats, 'DataValueField': 'Id', 'DataTextField': 'ContactFormatName', 'isNullableKey': false }
    ], {}, 'uVictimNotification', 'Edit', localizeDataItem);
}
function enrolleesVictimAddNotificationsPopup_OnComplete() {
    "use strict";
    var lBuilder = new SumoPredicateBuilder(),
        lFormats = getDataItems('UserContactFormat'),
        lMethods = [
            { 'Id': 1, 'Name': localizeText('cAgentPrimaryEmail') },
            { 'Id': 2, 'Name': localizeText('cAgentSecondaryEmail') },
            { 'Id': 3, 'Name': localizeText('cAgentPrimaryPhone') }],
        lEvents = getDataItems('NotificationType');
    lBuilder.AddNewExpressionConditional('IsImmediate', true, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    lEvents = query(lEvents, lBuilder.RootExpression);
    populateEditView(new Notification(), [
        { 'Id': 'NotificationTypeId', 'Type': 'Dropdown', 'DataSource': lEvents, 'LocaleName': 'NotificationType', 'DataValueField': 'Id', 'DataTextField': 'Name', 'isNullableKey': false },
        { 'Id': 'ContactTypeId', 'Type': 'Dropdown', 'DataSource': lMethods, 'DataValueField': 'Id', 'DataTextField': 'Name', 'isNullableKey': false },
        { 'Id': 'ContactFormatId', 'Type': 'Dropdown', 'DataSource': lFormats, 'DataValueField': 'Id', 'DataTextField': 'ContactFormatName', 'isNullableKey': false }

    ], {}, 'uVictimNotification', 'Edit', localizeDataItem);
}

function AddVictimNotificationsPopup_Init() {
    "use strict";
    var lButtonCommandBar = GenerateButtonCommandBar();
    var lEnrollee = getDataItem(mEnrolleesData.VictimProfileCurrent.Id, 'Enrollees');

    if (lEnrollee.PrimaryId) {
        $(GenerateButton(localizeWrapper('cEnrolleeSave'), 'Save', 'enrolleesVictimAddImmediateNotifications_OnClick()')).appendTo(lButtonCommandBar);
        $(GenerateButton(localizeWrapper('cEnrolleeCancel'), 'Cancel', 'ClosePopup()')).appendTo(lButtonCommandBar);
        DisplayPopup(localizeWrapper('cAgentAddNotifications'), '<div id="uVictimNotificationsPopupPanel"></div>', lButtonCommandBar, false);
        populateElement('uVictimNotificationsPopupPanel', 'Enrollees.Victims.Notifications.EditPopup.Layout.htm', enrolleesVictimAddNotificationsPopup_OnComplete);
    } else {
        displayVictimNotFinishedPopup();
    }
}

function displayVictimNotFinishedPopup() {
    "use strict";
    var lButtonCommandBar = GenerateButtonCommandBar();

    $(GenerateButton(localizeWrapper('cOk'), 'Cancel', 'ClosePopup()')).appendTo(lButtonCommandBar);
    DisplayPopup(localizeWrapper('cAgentAddNotifications'), '<div id="uVictimNotificationsPopupPanel">'+ localizeWrapper('cEnrolleeVictimNotFinished') +'</div>', lButtonCommandBar, false);

}

function enrolleesVictimEditImmediateNotifications_OnClick() {
    "use strict";
    var lSelectedItems = mEnrolleesControls.VictimNotificationsListView.selectedDataItem(),
        lNotification,
        lBuilder = new SumoPredicateBuilder(),
        lContactTypeId = parseInt($('#uVictimNotificationContactTypeIdEdit').val()),
        lNotificationTypeId = parseInt($('#uVictimNotificationNotificationTypeIdEdit').val()),
        lFormatTypeId = parseInt($('#uVictimNotificationContactFormatIdEdit').val()),
        lQuery;

    lBuilder.AddNewExpressionConditional('ContactFormatId', lFormatTypeId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    lBuilder.AddNewExpressionConditional('ContactTypeId', lContactTypeId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    lBuilder.AddNewExpressionConditional('NotificationTypeId', lNotificationTypeId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    lBuilder.AddNewExpressionConditional('IsActive', true, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    lBuilder.AddNewExpressionConditional('AgentId', mEnrolleesData.VictimProfileCurrent.VictimUserId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    lQuery = query(mEnrolleesData.VictimNotifications, lBuilder.RootExpression);
    if (lSelectedItems[0]) {
        if (lQuery.length > 0) {
            mActivityNotification.addNotification(localizeWrapper('cAgentNotificationAlreadyExists'));
            ClosePopup();
        } else {
            lNotification = lSelectedItems[0];
            lNotification.ContactTypeId = lContactTypeId;
            lNotification.UserContactPriority = lContactTypeId;
            lNotification.ContactFormatId = lFormatTypeId;
            lNotification.NotificationTypeId = lNotificationTypeId;
            WriteMultiple([lNotification], enrolleesVictimNotifications_OnComplete, null, {}, true);
        }
    }
}

function enrolleesVictimEditNotificationPopup_OnComplete() {
    "use strict";
    var lSelectedItems = mEnrolleesControls.VictimNotificationsListView.selectedDataItem(),
        lBuilder = new SumoPredicateBuilder(),
        lMethods = [
            { 'Id': 1, 'Name': localizeText('cAgentPrimaryEmail') },
            { 'Id': 2, 'Name': localizeText('cAgentSecondaryEmail') },
            { 'Id': 3, 'Name': localizeText('cAgentPrimaryPhone') }],
        lFormats = getDataItems('UserContactFormat'),
        lEvents = getDataItems('NotificationType');

    lBuilder.AddNewExpressionConditional('IsImmediate', true, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    lEvents = query(lEvents, lBuilder.RootExpression);

    populateEditView(lSelectedItems[0], [
        { 'Id': 'NotificationTypeId', 'Type': 'Dropdown', 'DataSource': lEvents, 'LocaleName': 'NotificationType', 'DataValueField': 'Id', 'DataTextField': 'Name', 'isNullableKey': false },
        { 'Id': 'ContactTypeId', 'Type': 'Dropdown', 'DataSource': lMethods, 'DataValueField': 'Id', 'DataTextField': 'Name', 'isNullableKey': false },
        { 'Id': 'ContactFormatId', 'Type': 'Dropdown', 'DataSource': lFormats, 'DataValueField': 'Id', 'DataTextField': 'ContactFormatName', 'isNullableKey': false }
    ], {}, 'uVictimNotification', 'Edit', localizeDataItem);
    victimNotificationMethod_OnChange();
}

function EditVictimNotificationPopup_Init() {
    "use strict";
    var lButtonCommandBar = GenerateButtonCommandBar();
    $(GenerateButton(localizeWrapper('cEnrolleeSave'), 'Save', 'enrolleesVictimEditImmediateNotifications_OnClick()')).appendTo(lButtonCommandBar);
    $(GenerateButton(localizeWrapper('cEnrolleeCancel'), 'Cancel', 'ClosePopup()')).appendTo(lButtonCommandBar);
    DisplayPopup(localizeWrapper('cAgentEditNotification'), '<div id="uVictimNotificationsPopupPanel"></div>', lButtonCommandBar, false);
    populateElement('uVictimNotificationsPopupPanel', 'Enrollees.Victims.Notifications.EditPopup.Layout.htm', enrolleesVictimEditNotificationPopup_OnComplete);
}

function mStateManagerEnrolleesSecondaryNotifications_Init() {
    "use strict";
    uEnrolleesVictimsListView_Init();
}

function EnrolleeProfileNotifications_Init(aEnrolleeId) {
    "use strict";
    uEnrolleesVictimsListView_Init();
}